import { Fragment, computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createSlots, createTextVNode, createVNode, defineComponent, guardReactiveProps, mergeModels, mergeProps, nextTick, normalizeClass, normalizeProps, normalizeStyle, openBlock, reactive, ref, renderList, renderSlot, resolveComponent, toDisplayString, unref, useModel, useTemplateRef, watch, withCtx, withModifiers } from "vue";
import { Blob, Integer, Label, ParameterDict, ParameterList, Size2D, Type, buildParameterValue } from "@robovision/data";
import { ValidationBuilder, appendFloatScalarValidation, appendIntegerScalarValidation, scalarNumericBoundsFromDefinition } from "@robovision/rvai-base";
import useVuelidate from "@vuelidate/core";
import { useI18n } from "vue-i18n";
import { QIcon, QItem, QItemLabel, QItemSection, QList, QMenu } from "quasar";
//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
//#endregion
//#region src/composables/useOptions.ts
var defaultOptions = () => ({ extraComponents: [] });
var globalOptions = defaultOptions();
function provideOptions(options = defaultOptions()) {
	globalOptions = options;
}
function useOptions() {
	return globalOptions;
}
//#endregion
//#region src/components/params/ReadOnlyParam.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$13 = { key: 0 };
var _hoisted_2$5 = {
	key: 0,
	class: "text-body3 multiline"
};
var _hoisted_3$1 = {
	key: 1,
	class: "column"
};
var _hoisted_4 = { class: "row no-wrap items-baseline q-pr-xs" };
var _hoisted_5 = { class: "text-subtitle3 multiline" };
var _hoisted_6 = {
	key: 2,
	class: "row no-wrap items-baseline"
};
var _hoisted_7 = { class: "row no-wrap items-baseline" };
var _hoisted_8 = { class: "single-line text-subtitle3 q-pl-xs" };
var ReadOnlyParam_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "ReadOnlyParam",
	props: {
		name: {
			required: true,
			type: String
		},
		value: {
			default: void 0,
			type: [
				Number,
				String,
				Boolean
			]
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	setup(__props) {
		const props = __props;
		const { t: $t } = useI18n();
		const multiline = computed(() => typeof props.value === "string" && props.value.includes("\n"));
		return (_ctx, _cache) => {
			const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
			return __props.valueOnly ? (openBlock(), createElementBlock("div", _hoisted_1$13, [multiline.value ? (openBlock(), createElementBlock("div", _hoisted_2$5, [createVNode(_component_rv_ellipsis_text, { text: __props.value?.toString() ?? unref($t)("rvai-params.general.none") }, null, 8, ["text"])])) : (openBlock(), createBlock(_component_rv_ellipsis_text, {
				key: 1,
				class: "text-body3",
				text: __props.value?.toString() ?? unref($t)("rvai-params.general.none")
			}, null, 8, ["text"]))])) : multiline.value ? (openBlock(), createElementBlock("div", _hoisted_3$1, [createElementVNode("div", _hoisted_4, [createVNode(_component_rv_ellipsis_text, {
				class: "text-body3",
				text: __props.name
			}, null, 8, ["text"]), createTextVNode(" " + toDisplayString(unref($t)("rvai-params.general.symbols.colon")), 1)]), createElementVNode("div", _hoisted_5, toDisplayString(__props.value ?? unref($t)("rvai-params.general.none")), 1)])) : (openBlock(), createElementBlock("div", _hoisted_6, [createVNode(_component_rv_ellipsis_text, {
				class: "text-body3",
				text: __props.name
			}, null, 8, ["text"]), createElementVNode("div", _hoisted_7, [createTextVNode(toDisplayString(unref($t)("rvai-params.general.symbols.colon")) + " ", 1), createElementVNode("span", _hoisted_8, toDisplayString(__props.value ?? unref($t)("rvai-params.general.none")), 1)])]));
		};
	}
});
//#endregion
//#region \0plugin-vue:export-helper
var _plugin_vue_export_helper_default = (sfc, props) => {
	const target = sfc.__vccOpts || sfc;
	for (const [key, val] of props) target[key] = val;
	return target;
};
//#endregion
//#region src/components/params/ReadOnlyParam.vue
var ReadOnlyParam_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ReadOnlyParam_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-932d28a2"]]);
//#endregion
//#region src/components/params/BooleanParam.vue
var BooleanParam_default = /* @__PURE__ */ defineComponent({
	__name: "BooleanParam",
	props: {
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		modelValue: {
			default: void 0,
			type: Boolean
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const i18nInstance = useI18n();
		const emit = __emit;
		const value = computed({
			get() {
				return props.modelValue;
			},
			set(value) {
				const updated = value != null ? buildParameterValue("Boolean", value) : void 0;
				emit("update:modelValue", updated);
			}
		});
		const valueLabel = computed(() => {
			switch (value.value) {
				case true: return i18nInstance.t("rvai-params.general.yes");
				case false: return i18nInstance.t("rvai-params.general.no");
				default: return i18nInstance.t("rvai-params.general.unset");
			}
		});
		useVuelidate(computed(() => ({ value: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).rules })), computed(() => ({ value: value.value })), { $autoDirty: true });
		return (_ctx, _cache) => {
			const _component_rv_toggle = resolveComponent("rv-toggle");
			return !__props.readonly ? (openBlock(), createBlock(_component_rv_toggle, {
				key: 0,
				modelValue: value.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
				class: "q-py-sm",
				disable: __props.disable,
				"info-text": __props.definition.description ?? void 0,
				label: __props.definition.name
			}, null, 8, [
				"modelValue",
				"disable",
				"info-text",
				"label"
			])) : (openBlock(), createBlock(ReadOnlyParam_default, mergeProps({ key: 1 }, _ctx.$attrs, {
				name: __props.definition.name,
				value: valueLabel.value,
				"value-only": __props.valueOnly
			}), null, 16, [
				"name",
				"value",
				"value-only"
			]));
		};
	}
});
//#endregion
//#region src/components/params/DictBoolParam.vue
var DictBoolParam_default = /* @__PURE__ */ defineComponent({
	__name: "DictBoolParam",
	props: {
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		modelValue: {
			default: void 0,
			type: Object
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const i18nInstance = useI18n();
		const { t: $t } = i18nInstance;
		const emit = __emit;
		const allSelected = computed(() => {
			return [...props.modelValue?.values() ?? []].every((e) => e.value);
		});
		const hasSelected = computed(() => {
			return [...props.modelValue?.values() ?? []].some((e) => e.value);
		});
		const options = computed(() => {
			return props.definition.keys?.enum || [];
		});
		const selected = computed({
			get() {
				return [...props.modelValue?.entries() ?? []].filter(([, { value }]) => value).map(([key]) => key);
			},
			set(value) {
				const items = options.value.map((opt) => [opt, value.includes(opt)]);
				const updatedValue = ParameterDict.new().addItems(items).build();
				emit("update:modelValue", updatedValue);
			}
		});
		const value = computed(() => {
			if (!hasSelected.value) return void 0;
			if (allSelected.value) return $t("rvai-params.general.allSelected");
			return [...props.modelValue?.entries() ?? []].filter(([, { value }]) => value).map(([key]) => key).join("\n");
		});
		const v$ = useVuelidate(computed(() => ({ selected: ValidationBuilder.withLabel(props.definition.name, i18nInstance).rules })), { selected: selected.value }, { $autoDirty: true });
		return (_ctx, _cache) => {
			const _component_rv_multiple_select = resolveComponent("rv-multiple-select");
			return !__props.readonly ? (openBlock(), createBlock(_component_rv_multiple_select, {
				key: 0,
				modelValue: selected.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selected.value = $event),
				"all-selected-text": unref($t)("rvai-params.general.allSelected"),
				class: "dict-param full-width",
				disable: __props.disable,
				"info-text": __props.definition.description,
				label: __props.definition.name,
				options: options.value,
				validation: unref(v$).selected,
				"with-chips": ""
			}, null, 8, [
				"modelValue",
				"all-selected-text",
				"disable",
				"info-text",
				"label",
				"options",
				"validation"
			])) : (openBlock(), createBlock(ReadOnlyParam_default, mergeProps({ key: 1 }, _ctx.$attrs, {
				name: __props.definition.name,
				value: value.value,
				"value-only": __props.valueOnly
			}), null, 16, [
				"name",
				"value",
				"value-only"
			]));
		};
	}
});
//#endregion
//#region ../../../../node_modules/uuid/dist/stringify.js
var byteToHex = [];
for (let i = 0; i < 256; ++i) byteToHex.push((i + 256).toString(16).slice(1));
function unsafeStringify(arr, offset = 0) {
	return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
//#endregion
//#region ../../../../node_modules/uuid/dist/rng.js
var rnds8 = /* @__PURE__ */ new Uint8Array(16);
function rng() {
	return crypto.getRandomValues(rnds8);
}
//#endregion
//#region ../../../../node_modules/uuid/dist/v4.js
function v4(options, buf, offset) {
	if (!buf && !options && crypto.randomUUID) return crypto.randomUUID();
	return _v4(options, buf, offset);
}
function _v4(options, buf, offset) {
	options = options || {};
	const rnds = options.random ?? options.rng?.() ?? rng();
	if (rnds.length < 16) throw new Error("Random bytes length must be >= 16");
	rnds[6] = rnds[6] & 15 | 64;
	rnds[8] = rnds[8] & 63 | 128;
	if (buf) {
		offset = offset || 0;
		if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
		for (let i = 0; i < 16; ++i) buf[offset + i] = rnds[i];
		return buf;
	}
	return unsafeStringify(rnds);
}
//#endregion
//#region src/components/params/DictKeyValueParam.vue
var DictKeyValueParam_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "DictKeyValueParam",
	props: {
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		modelValue: {
			default: void 0,
			type: Object
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const i18nInstance = useI18n();
		const { t: $t } = i18nInstance;
		function storedValueToInputString(stored) {
			if (stored === null) return "";
			if (typeof stored === "string") return stored;
			if (typeof stored === "number" || typeof stored === "bigint") return String(stored);
			if (typeof stored === "boolean") return String(stored);
			if (typeof stored === "object" && "value" in stored) {
				const inner = stored.value;
				return String(inner);
			}
			return String(stored);
		}
		function coerceDictValueForEmit(raw) {
			const valuesDef = props.definition.values;
			const trimmed = raw.trim();
			if (valuesDef.type === "Integer") {
				if (trimmed === "") return "";
				const n = Number(trimmed);
				if (Number.isFinite(n)) return buildParameterValue("Integer", n);
				return raw;
			}
			if (valuesDef.type === "Float") {
				if (trimmed === "") return "";
				const n = Number(trimmed);
				if (Number.isFinite(n)) return buildParameterValue("Float", n);
				return raw;
			}
			return raw;
		}
		function getDefaultValue() {
			const emptyValue = {
				id: v4(),
				row: ["", ""]
			};
			const entries = [...props.modelValue?.entries() ?? []];
			if (entries.length > 0) return entries.map(([key, node]) => ({
				id: node.id,
				row: [key, storedValueToInputString(node.value)]
			}));
			return [emptyValue];
		}
		const rows = ref(getDefaultValue());
		function removeRow(rowIndex) {
			rows.value = rows.value.toSpliced(rowIndex, 1);
			updateValue();
		}
		function setDictValue(value, rowIndex) {
			const id = rows.value[rowIndex] ? rows.value[rowIndex].id : v4();
			rows.value[rowIndex] = {
				id,
				row: value
			};
			updateValue();
		}
		async function updateValue() {
			const pairs = rows.value.filter(({ row }) => {
				const [key, value] = row;
				return !!key || !!value;
			}).map(({ row }) => {
				const [key, valueStr] = row;
				return [key, coerceDictValueForEmit(valueStr)];
			});
			const updatedValue = ParameterDict.new().addItems(pairs).build();
			emit("update:modelValue", updatedValue);
			await nextTick();
			v$.value.$validate();
		}
		const value = computed(() => {
			const entries = [...props.modelValue?.entries() ?? []];
			if (!entries.length || entries.every(([key]) => !key)) return void 0;
			return entries.map(([key, node]) => `${key}: ${storedValueToInputString(node.value)}`).join("\n");
		});
		const v$ = useVuelidate(computed(() => rows.value.reduce((acc, { id, row: [key, value] }) => ({
			...acc,
			[`${id}-key`]: ValidationBuilder.withLabel(props.definition.name, i18nInstance).custom((key) => {
				return rows.value.filter(({ row }) => {
					return row[0] === key;
				}).length < 2;
			}, "rvai-params.errors.duplicatedKeys", [], "duplicatedKeys").custom((key) => {
				if (value) return !!key.trim();
				return true;
			}, "rvai-params.errors.bothAreRequired", [], "requiredIf").custom((key) => {
				if (rows.value.length > 1) return !!key.trim();
				return true;
			}, "rvai-params.errors.bothAreRequired", [], "requiredIfHasOtherKeyValue").maxLength(props.definition.keys?.maxLength).minLength(props.definition.keys?.minLength).oneOfRegexes(props.definition.keys?.pattern?.map((p) => new RegExp(p)) ?? []).rules,
			[`${id}-value`]: (() => {
				const valuesDef = props.definition.values;
				let valueBuilder = ValidationBuilder.withLabel(props.definition.name, i18nInstance).custom((value) => {
					if (key && !props.definition.values.optional) return !!value.trim();
					return true;
				}, "rvai-params.errors.bothAreRequired", [], "requiredIf");
				if (valuesDef.type === "Integer") valueBuilder = appendIntegerScalarValidation(valueBuilder, scalarNumericBoundsFromDefinition(valuesDef));
				else if (valuesDef.type === "Float") valueBuilder = appendFloatScalarValidation(valueBuilder, scalarNumericBoundsFromDefinition(valuesDef));
				return valueBuilder.maxLength("maxLength" in valuesDef ? valuesDef.maxLength : null).minLength("minLength" in valuesDef ? valuesDef.minLength : null).oneOfRegexes("pattern" in valuesDef ? valuesDef.pattern?.map((p) => new RegExp(p)) ?? [] : []).rules;
			})()
		}), {})), computed(() => rows.value.reduce((acc, { id, row: [key, value] }) => ({
			...acc,
			[`${id}-key`]: key,
			[`${id}-value`]: value
		}), {})), { $autoDirty: true });
		watch(() => props.modelValue, (curr, prev) => {
			if (![...prev?.entries() ?? []].length) return;
			if (![...curr?.entries() ?? []].length) {
				rows.value = getDefaultValue();
				updateValue();
			}
		});
		return (_ctx, _cache) => {
			const _component_rv_combined_inputs = resolveComponent("rv-combined-inputs");
			const _component_rv_button = resolveComponent("rv-button");
			return !__props.readonly ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(rows.value, (v, i) => {
				return openBlock(), createElementBlock("div", {
					key: v.id,
					class: "dict-key-value-param row full-width no-wrap justify-between items-start"
				}, [
					createVNode(_component_rv_combined_inputs, {
						class: normalizeClass(["dict-key-value-param__row", { "q-mb-md": rows.value.length - 1 !== i }]),
						"data-automation": "dict-key-value-param__row",
						disable: __props.disable,
						hint: "",
						"info-text": __props.definition.description,
						label: i ? "" : __props.definition.name,
						"model-value": v.row,
						placeholders: [unref($t)("rvai-params.general.key"), unref($t)("rvai-params.general.value")],
						readonly: __props.readonly,
						separator: ":",
						"show-optional-label": __props.definition.optional,
						validation: [unref(v$)[`${v.id}-key`], unref(v$)[`${v.id}-value`]],
						"onUpdate:modelValue": ($event) => setDictValue($event, i)
					}, null, 8, [
						"class",
						"disable",
						"info-text",
						"label",
						"model-value",
						"placeholders",
						"readonly",
						"show-optional-label",
						"validation",
						"onUpdate:modelValue"
					]),
					!__props.readonly ? (openBlock(), createBlock(_component_rv_button, {
						key: 0,
						class: normalizeClass(["dict-key-value-param__btn q-ml-sm", { "dict-key-value-param__btn--first-row": !i }]),
						"data-automation": "dict-key-value-param__add",
						disable: !v.row[0].length || !v.row[1].length || !!rows.value[i + 1],
						icon: "mdi-plus",
						size: "sm",
						tertiary: "",
						onClick: ($event) => setDictValue(["", ""], i + 1)
					}, null, 8, [
						"class",
						"disable",
						"onClick"
					])) : createCommentVNode("", true),
					!__props.readonly ? (openBlock(), createBlock(_component_rv_button, {
						key: 1,
						class: normalizeClass(["dict-key-value-param__btn q-ml-sm", { "dict-key-value-param__btn--first-row": !i }]),
						"data-automation": "dict-key-value-param__remove",
						disable: rows.value.length === 1,
						icon: "mdi-delete",
						size: "sm",
						tertiary: "",
						onClick: ($event) => removeRow(i)
					}, null, 8, [
						"class",
						"disable",
						"onClick"
					])) : createCommentVNode("", true)
				]);
			}), 128)) : (openBlock(), createBlock(ReadOnlyParam_default, mergeProps({ key: 1 }, _ctx.$attrs, {
				name: __props.definition.name,
				value: value.value,
				"value-only": __props.valueOnly
			}), null, 16, [
				"name",
				"value",
				"value-only"
			]));
		};
	}
}), [["__scopeId", "data-v-8113b446"]]);
//#endregion
//#region src/components/params/EnumParam.vue
var EnumParam_default = /* @__PURE__ */ defineComponent({
	__name: "EnumParam",
	props: {
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		modelValue: {
			default: void 0,
			type: String
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const value = computed({
			get() {
				return props.modelValue;
			},
			set(value) {
				const updated = value != null ? buildParameterValue("Text", value) : value;
				emit("update:modelValue", updated);
			}
		});
		const i18nInstance = useI18n();
		const v$ = useVuelidate(computed(() => ({ value: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).rules })), computed(() => ({ value: value.value })), { $autoDirty: true });
		return (_ctx, _cache) => {
			const _component_rv_select = resolveComponent("rv-select");
			return !__props.readonly ? (openBlock(), createBlock(_component_rv_select, {
				key: 0,
				modelValue: value.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
				disable: __props.disable,
				"info-text": __props.definition.description,
				label: __props.definition.name,
				options: __props.definition.enum ?? [],
				readonly: __props.readonly,
				"show-optional-label": __props.definition.optional,
				validation: unref(v$).value
			}, null, 8, [
				"modelValue",
				"disable",
				"info-text",
				"label",
				"options",
				"readonly",
				"show-optional-label",
				"validation"
			])) : (openBlock(), createBlock(ReadOnlyParam_default, mergeProps({ key: 1 }, _ctx.$attrs, {
				name: __props.definition.name,
				value: value.value,
				"value-only": __props.valueOnly
			}), null, 16, [
				"name",
				"value",
				"value-only"
			]));
		};
	}
});
//#endregion
//#region src/components/params/FileParam.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$12 = {
	key: 0,
	class: "file-param"
};
//#endregion
//#region src/components/params/FileParam.vue
var FileParam_default = /* @__PURE__ */ defineComponent({
	__name: "FileParam",
	props: {
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		modelValue: {
			default: void 0,
			type: Object
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const file = ref([]);
		const value = computed(() => file.value && file.value.length ? file.value[0].name : void 0);
		async function updateValue(value) {
			file.value = value;
			if (value && value.length) emit("update:modelValue", await Blob.fromFile(value[0]));
			else clearAll();
		}
		function clearAll() {
			emit("update:modelValue", void 0);
		}
		return (_ctx, _cache) => {
			const _component_rv_dropzone = resolveComponent("rv-dropzone");
			return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1$12, [createVNode(_component_rv_dropzone, {
				"allowed-extensions": props.definition.extension,
				disable: __props.disable,
				"max-files": 1,
				"model-value": __props.modelValue,
				multiple: false,
				onClear: clearAll,
				"onUpdate:modelValue": updateValue
			}, null, 8, [
				"allowed-extensions",
				"disable",
				"model-value"
			])])) : (openBlock(), createBlock(ReadOnlyParam_default, mergeProps({ key: 1 }, _ctx.$attrs, {
				name: __props.definition.name,
				value: value.value,
				"value-only": __props.valueOnly
			}), null, 16, [
				"name",
				"value",
				"value-only"
			]));
		};
	}
});
//#endregion
//#region src/components/params/FloatParam.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$11 = {
	key: 0,
	class: "row no-wrap items-end"
};
//#endregion
//#region src/components/params/FloatParam.vue
var FloatParam_default = /* @__PURE__ */ defineComponent({
	__name: "FloatParam",
	props: {
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		modelValue: {
			default: void 0,
			type: [Object, Number]
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const i18nInstance = useI18n();
		const isSlider = computed(() => props.definition.widget === "slider" && props.definition.maximum != null && props.definition.minimum != null);
		const valueRef = ref(typeof props.modelValue === "number" ? props.modelValue : props.modelValue?.value);
		const isPercentage = computed(() => props.definition.widget === "percentage");
		const value = computed({
			get() {
				return isPercentage.value && valueRef.value ? valueRef.value * 100 : valueRef.value;
			},
			set(value) {
				valueRef.value = isPercentage.value && value ? value / 100 : value;
				if (valueRef.value == null) emit("update:modelValue", void 0);
				else {
					const parsed = Number(valueRef.value);
					if (!isNaN(parsed)) {
						const updated = buildParameterValue("Float", parsed);
						emit("update:modelValue", updated);
					}
				}
			}
		});
		const numericBounds = computed(() => scalarNumericBoundsFromDefinition(props.definition));
		const v$ = useVuelidate(computed(() => ({ value: appendFloatScalarValidation(ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional), numericBounds.value).rules })), computed(() => ({ value: valueRef.value })), { $autoDirty: true });
		watch(() => props.modelValue, () => {
			const newValue = typeof props.modelValue === "number" ? props.modelValue : props.modelValue?.value;
			if (Number(valueRef.value) !== Number(newValue)) valueRef.value = newValue;
		});
		return (_ctx, _cache) => {
			const _component_rv_slider = resolveComponent("rv-slider");
			const _component_rv_input = resolveComponent("rv-input");
			return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1$11, [isSlider.value ? (openBlock(), createBlock(_component_rv_slider, {
				key: 0,
				modelValue: value.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
				class: "full-width",
				disable: __props.disable,
				float: "",
				"info-text": __props.definition.description,
				"input-decimals": 3,
				label: __props.definition.name,
				max: __props.definition.maximum,
				min: __props.definition.minimum,
				readonly: __props.readonly,
				"show-optional-label": __props.definition.optional,
				step: .1,
				suffix: isPercentage.value ? "%" : void 0,
				validation: unref(v$).value,
				"with-input": ""
			}, null, 8, [
				"modelValue",
				"disable",
				"info-text",
				"label",
				"max",
				"min",
				"readonly",
				"show-optional-label",
				"suffix",
				"validation"
			])) : (openBlock(), createBlock(_component_rv_input, {
				key: 1,
				modelValue: value.value,
				"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => value.value = $event),
				class: "full-width",
				disable: __props.disable,
				"info-text": __props.definition.description,
				label: __props.definition.name,
				readonly: __props.readonly,
				"show-optional-label": __props.definition.optional,
				suffix: isPercentage.value ? "%" : void 0,
				validation: unref(v$).value
			}, null, 8, [
				"modelValue",
				"disable",
				"info-text",
				"label",
				"readonly",
				"show-optional-label",
				"suffix",
				"validation"
			]))])) : (openBlock(), createBlock(ReadOnlyParam_default, mergeProps({ key: 1 }, _ctx.$attrs, {
				name: __props.definition.name,
				value: value.value,
				"value-only": __props.valueOnly
			}), null, 16, [
				"name",
				"value",
				"value-only"
			]));
		};
	}
});
//#endregion
//#region src/components/params/FloatRangeParam.vue
var FloatRangeParam_default = /* @__PURE__ */ defineComponent({
	__name: "FloatRangeParam",
	props: {
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		modelValue: {
			default: void 0,
			type: [Object]
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const i18nInstance = useI18n();
		const defaultValues = computed(() => Object.assign({
			lowerBound: .3,
			lowerInclusive: false,
			upperBound: .5,
			upperInclusive: false
		}, props.definition.default));
		const valueRef = ref(getRangeValue(props.modelValue));
		const value = computed({
			get() {
				return valueRef.value;
			},
			set(value) {
				valueRef.value = value;
				emit("update:modelValue", buildParameterValue("FloatRange", {
					lowerBound: valueRef.value.min,
					lowerInclusive: props.modelValue?.lowerInclusive ?? defaultValues.value.lowerInclusive,
					upperBound: valueRef.value.max,
					upperInclusive: props.modelValue?.upperInclusive ?? defaultValues.value.upperInclusive
				}));
			}
		});
		const maxValue = computed(() => props.definition.exclusiveMaximum ?? props.definition.maximum);
		const hasMaxValue = computed(() => maxValue.value != null);
		const maxValueExclusive = computed(() => props.definition.exclusiveMaximum != null);
		const minValue = computed(() => props.definition.minimum ?? props.definition.exclusiveMinimum);
		const hasMinValue = computed(() => minValue.value != null);
		const minValueExclusive = computed(() => props.definition.exclusiveMinimum != null);
		const v$ = useVuelidate(computed(() => ({
			max: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).numeric.decimal.maxValueIf(hasMaxValue.value, maxValue.value, !maxValueExclusive.value).rules,
			min: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).numeric.decimal.minValueIf(hasMinValue.value, minValue.value, !minValueExclusive.value).rules
		})), computed(() => ({
			max: valueRef.value.max,
			min: valueRef.value.min
		})), { $autoDirty: true });
		function getRangeValue(value) {
			return {
				max: value?.upperBound ?? defaultValues.value.upperBound,
				min: value?.lowerBound ?? defaultValues.value.lowerBound
			};
		}
		watch(() => props.modelValue, (newValue) => {
			valueRef.value = getRangeValue(newValue);
		});
		return (_ctx, _cache) => {
			const _component_rv_range = resolveComponent("rv-range");
			return !__props.readonly ? (openBlock(), createBlock(_component_rv_range, {
				key: 0,
				modelValue: value.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
				class: "full-width",
				disable: __props.disable,
				"info-text": __props.definition.description ?? void 0,
				"input-decimals": 3,
				label: __props.definition.name,
				max: __props.definition.maximum ?? void 0,
				min: __props.definition.minimum ?? void 0,
				"show-optional-label": __props.definition.optional,
				step: .1,
				validation: unref(v$).value,
				"with-input": ""
			}, null, 8, [
				"modelValue",
				"disable",
				"info-text",
				"label",
				"max",
				"min",
				"show-optional-label",
				"validation"
			])) : (openBlock(), createBlock(ReadOnlyParam_default, mergeProps({ key: 1 }, _ctx.$attrs, {
				name: __props.definition.name,
				value: props.modelValue ? `${props.modelValue.lowerBound} - ${props.modelValue.upperBound}` : void 0,
				"value-only": __props.valueOnly
			}), null, 16, [
				"name",
				"value",
				"value-only"
			]));
		};
	}
});
//#endregion
//#region src/components/params/GroupParam.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$10 = {
	key: 0,
	class: "text-small text-grey-1 q-pt-md"
};
//#endregion
//#region src/components/params/GroupParam.vue
var GroupParam_default = /* @__PURE__ */ defineComponent({
	__name: "GroupParam",
	props: {
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		modelValue: {
			default: void 0,
			type: Object
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const expanded = ref(false);
		function onUpdateParam(key, value) {
			emit("update:modelValue", {
				...props.modelValue && props.modelValue,
				[key]: value
			});
		}
		return (_ctx, _cache) => {
			const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
			const _component_rv_parameter = resolveComponent("rv-parameter");
			const _component_rv_expansion_item = resolveComponent("rv-expansion-item");
			return openBlock(), createBlock(_component_rv_expansion_item, {
				modelValue: expanded.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => expanded.value = $event),
				class: "rv-group-param",
				dense: "",
				"switch-toggle-side": ""
			}, {
				header: withCtx(() => [createVNode(unref(QItemSection), null, {
					default: withCtx(() => [createVNode(_component_rv_ellipsis_text, {
						class: "text-subtitle3",
						disable: __props.disable,
						text: __props.definition.name
					}, null, 8, ["disable", "text"])]),
					_: 1
				})]),
				default: withCtx(() => [__props.definition.description ? (openBlock(), createElementBlock("div", _hoisted_1$10, toDisplayString(__props.definition.description), 1)) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(__props.definition.fields, (param, key) => {
					return openBlock(), createBlock(_component_rv_parameter, {
						key,
						class: "q-my-md q-mx-sm",
						definition: param,
						disable: __props.disable,
						"model-value": __props.modelValue ? __props.modelValue[key] : void 0,
						readonly: __props.readonly,
						"value-only": __props.valueOnly,
						"onUpdate:modelValue": ($event) => onUpdateParam(key, $event)
					}, null, 8, [
						"definition",
						"disable",
						"model-value",
						"readonly",
						"value-only",
						"onUpdate:modelValue"
					]);
				}), 128))]),
				_: 1
			}, 8, ["modelValue"]);
		};
	}
});
//#endregion
//#region src/components/params/IntegerParam.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$9 = {
	key: 0,
	class: "row no-wrap items-end"
};
//#endregion
//#region src/components/params/IntegerParam.vue
var IntegerParam_default = /* @__PURE__ */ defineComponent({
	__name: "IntegerParam",
	props: {
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		modelValue: {
			default: void 0,
			type: [
				Object,
				Number,
				BigInt
			]
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const i18nInstance = useI18n();
		function isInteger64(value) {
			return typeof value === "bigint" || value instanceof Integer && value.type === Type.Integer64;
		}
		function toNumber(value) {
			const raw = value instanceof Integer ? value.value : value;
			return raw == null ? void 0 : Number(raw);
		}
		const is64Bit = ref(isInteger64(props.modelValue));
		const valueRef = ref(toNumber(props.modelValue));
		const value = computed({
			get() {
				return valueRef.value;
			},
			set(value) {
				valueRef.value = value;
				if (value == null) {
					emit("update:modelValue", void 0);
					return;
				}
				const parsed = Number(value);
				if (!Number.isInteger(parsed)) return;
				emit("update:modelValue", is64Bit.value ? buildParameterValue("Integer", BigInt(parsed)) : buildParameterValue("Integer", parsed));
			}
		});
		const isSlider = computed(() => props.definition.widget === "slider" && props.definition.maximum != null && props.definition.minimum != null);
		const numericBounds = computed(() => scalarNumericBoundsFromDefinition(props.definition));
		const v$ = useVuelidate(computed(() => ({ value: appendIntegerScalarValidation(ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional), numericBounds.value).rules })), computed(() => ({ value: value.value })), { $autoDirty: true });
		watch(() => props.modelValue, () => {
			if (isInteger64(props.modelValue)) is64Bit.value = true;
			const newValue = toNumber(props.modelValue);
			if (Number(valueRef.value) !== Number(newValue)) valueRef.value = newValue;
		});
		return (_ctx, _cache) => {
			const _component_rv_slider = resolveComponent("rv-slider");
			const _component_rv_input = resolveComponent("rv-input");
			return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1$9, [isSlider.value ? (openBlock(), createBlock(_component_rv_slider, {
				key: 0,
				modelValue: value.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
				class: "full-width",
				disable: __props.disable,
				"info-text": __props.definition.description,
				label: __props.definition.name,
				max: __props.definition.maximum,
				min: __props.definition.minimum,
				readonly: __props.readonly,
				"show-optional-label": __props.definition.optional,
				validation: unref(v$).value,
				"with-input": ""
			}, null, 8, [
				"modelValue",
				"disable",
				"info-text",
				"label",
				"max",
				"min",
				"readonly",
				"show-optional-label",
				"validation"
			])) : (openBlock(), createBlock(_component_rv_input, {
				key: 1,
				modelValue: value.value,
				"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => value.value = $event),
				class: "full-width",
				disable: __props.disable,
				"info-text": __props.definition.description,
				label: __props.definition.name,
				readonly: __props.readonly,
				"show-optional-label": __props.definition.optional,
				validation: unref(v$).value
			}, null, 8, [
				"modelValue",
				"disable",
				"info-text",
				"label",
				"readonly",
				"show-optional-label",
				"validation"
			]))])) : (openBlock(), createBlock(ReadOnlyParam_default, mergeProps({ key: 1 }, _ctx.$attrs, {
				name: __props.definition.name,
				value: value.value,
				"value-only": __props.valueOnly
			}), null, 16, [
				"name",
				"value",
				"value-only"
			]));
		};
	}
});
//#endregion
//#region src/components/params/ListParam.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$8 = { key: 1 };
var _hoisted_2$4 = { class: "no-wrap flex-inline max-width-full" };
//#endregion
//#region src/components/params/ListParam.vue
var ListParam_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "ListParam",
	props: {
		dataDependencies: {
			default: void 0,
			type: Object
		},
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		modelValue: {
			default: void 0,
			type: Object
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const i18nInstance = useI18n();
		const { t: $t } = i18nInstance;
		const emit = __emit;
		const classes = computed(() => {
			return props.dataDependencies?.classes ?? [];
		});
		const options = computed(() => {
			return classes.value.map((c) => ({
				color: c.color,
				label: c.name,
				value: c.id
			}));
		});
		const selectedRef = ref(getSelectedOptionsValue(props.modelValue));
		const selected = computed({
			get() {
				return selectedRef.value;
			},
			set(value) {
				selectedRef.value = value;
				const updatedValue = ParameterList.new().addValues(value.map((o) => [o.value, new Label(o.value)])).build();
				emit("update:modelValue", updatedValue);
			}
		});
		const hasSelected = computed(() => {
			return selected.value.length > 0;
		});
		const allSelected = computed(() => {
			return classes.value.length > 0 && classes.value.every((c) => selected.value.some((s) => s.value === c.id));
		});
		const v$ = useVuelidate(computed(() => ({ selected: ValidationBuilder.withLabel(props.definition.name, i18nInstance).custom((value) => props.definition.optional || value.length > 0, "rvai-params.errors.selectionRequired").rules })), computed(() => ({ selected: selected.value })), { $autoDirty: true });
		function getSelectOptionValue(parameterNode) {
			return {
				color: classes.value.find((e) => e.id === parameterNode.key)?.color,
				label: parameterNode.key,
				value: parameterNode.key
			};
		}
		function getSelectedOptionsValue(value) {
			return (value ?? []).map(getSelectOptionValue);
		}
		watch(() => props.dataDependencies, () => {
			selectedRef.value = getSelectedOptionsValue(props.modelValue);
		});
		watch(() => props.modelValue, (newValue) => {
			selectedRef.value = getSelectedOptionsValue(newValue);
		});
		return (_ctx, _cache) => {
			const _component_rv_multiple_select = resolveComponent("rv-multiple-select");
			const _component_rv_bullet = resolveComponent("rv-bullet");
			const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
			return !__props.readonly ? (openBlock(), createBlock(_component_rv_multiple_select, {
				key: 0,
				modelValue: selected.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selected.value = $event),
				"all-selected-text": unref($t)("rvai-params.general.allSelected"),
				class: "full-width",
				disable: __props.disable,
				"info-text": __props.definition.description ?? void 0,
				label: __props.definition.name,
				options: options.value,
				validation: unref(v$).selected,
				"with-chips": ""
			}, null, 8, [
				"modelValue",
				"all-selected-text",
				"disable",
				"info-text",
				"label",
				"options",
				"validation"
			])) : (openBlock(), createElementBlock("div", _hoisted_1$8, [hasSelected.value && !allSelected.value ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(selected.value, (option) => {
				return openBlock(), createElementBlock("div", {
					key: option.value,
					class: "full-width q-pb-sm"
				}, [createElementVNode("div", _hoisted_2$4, [createVNode(_component_rv_bullet, {
					class: "q-pr-sm",
					color: option.color,
					"is-tooltip-shown": false,
					size: 8
				}, null, 8, ["color"]), createVNode(_component_rv_ellipsis_text, {
					class: "zero-min-width",
					text: option.value
				}, null, 8, ["text"])])]);
			}), 128)) : (openBlock(), createBlock(ReadOnlyParam_default, mergeProps({ key: 1 }, _ctx.$attrs, {
				name: __props.definition.name,
				value: allSelected.value ? unref($t)("rvai-params.general.allSelected") : void 0,
				"value-only": __props.valueOnly
			}), null, 16, [
				"name",
				"value",
				"value-only"
			]))]));
		};
	}
}), [["__scopeId", "data-v-c6c7db95"]]);
//#endregion
//#region src/components/params/Size2DParam.vue
var Size2DParam_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Size2DParam",
	props: {
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		modelValue: {
			default: void 0,
			type: Object
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const i18nInstance = useI18n();
		const currentValue = reactive({
			height: String(props.modelValue?.height ?? ""),
			width: String(props.modelValue?.width ?? "")
		});
		const arrayValue = computed({
			get() {
				return [currentValue.width, currentValue.height];
			},
			set(value) {
				const [width, height] = value;
				Object.assign(currentValue, {
					height,
					width
				});
				emitUpdate();
			}
		});
		const readOnlyValue = computed(() => {
			if (!props.modelValue) return void 0;
			const { height, width } = props.modelValue;
			return `${width} x ${height}`;
		});
		watch(() => props.modelValue, (value) => {
			Object.assign(currentValue, {
				height: String(value?.height ?? ""),
				width: String(value?.width ?? "")
			});
		});
		function emitUpdate() {
			const { height, width } = currentValue;
			if (!height || !width) return emit("update:modelValue", void 0);
			const parsedHeight = Number(height);
			const parsedWidth = Number(width);
			if (parsedHeight != null && !isNaN(parsedHeight) && parsedWidth != null && !isNaN(parsedWidth)) emit("update:modelValue", new Size2D(parsedHeight, parsedWidth));
			else return emit("update:modelValue", void 0);
		}
		const v$ = useVuelidate(computed(() => ({
			height: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).numeric.minValueIf(!props.definition.optional && props.definition.minSize?.width != null, props.definition.minSize?.width).maxValueIf(!props.definition.optional && props.definition.maxSize?.width != null, props.definition.maxSize?.width).equalTo(props.definition.exactSize?.width).rules,
			width: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).numeric.minValueIf(!props.definition.optional && props.definition.minSize?.width != null, props.definition.minSize?.width).maxValueIf(!props.definition.optional && props.definition.maxSize?.width != null, props.definition.maxSize?.width).equalTo(props.definition.exactSize?.width).rules
		})), currentValue, { $autoDirty: true });
		return (_ctx, _cache) => {
			const _component_rv_combined_inputs = resolveComponent("rv-combined-inputs");
			return !__props.readonly ? (openBlock(), createBlock(_component_rv_combined_inputs, {
				key: 0,
				modelValue: arrayValue.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => arrayValue.value = $event),
				class: "size2d-param full-width",
				disable: __props.disable,
				hint: "Width x height",
				"info-text": __props.definition.description,
				label: __props.definition.name,
				readonly: __props.readonly,
				separator: "x",
				validation: [unref(v$).width, unref(v$).height]
			}, null, 8, [
				"modelValue",
				"disable",
				"info-text",
				"label",
				"readonly",
				"validation"
			])) : (openBlock(), createBlock(ReadOnlyParam_default, mergeProps({ key: 1 }, _ctx.$attrs, {
				name: __props.definition.name,
				value: readOnlyValue.value,
				"value-only": __props.valueOnly
			}), null, 16, [
				"name",
				"value",
				"value-only"
			]));
		};
	}
}), [["__scopeId", "data-v-e4525143"]]);
//#endregion
//#region src/components/params/TextParam.vue
var TextParam_default = /* @__PURE__ */ defineComponent({
	__name: "TextParam",
	props: {
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		modelValue: {
			default: void 0,
			type: String
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const VALID_TYPES = [
			"text",
			"password",
			"textarea",
			"time",
			"date",
			"datetime-local"
		];
		function isValidType(value) {
			return VALID_TYPES.includes(value);
		}
		const props = __props;
		const emit = __emit;
		const i18nInstance = useI18n();
		const value = computed({
			get() {
				return props.modelValue;
			},
			set(value) {
				const updated = value ? buildParameterValue("Text", value) : null;
				emit("update:modelValue", updated);
			}
		});
		const type = computed(() => {
			const { widget } = props.definition;
			if (isValidType(widget)) return widget;
			else return;
		});
		const v$ = useVuelidate(computed(() => ({ value: ValidationBuilder.withLabel(props.definition.name, i18nInstance).requiredIf(!props.definition.optional).maxLength(props.definition?.maxLength).minLength(props.definition?.minLength).oneOfRegexes(props.definition?.pattern?.map((p) => new RegExp(p)) ?? []).rules })), computed(() => ({ value: value.value })), { $autoDirty: true });
		return (_ctx, _cache) => {
			const _component_rv_input = resolveComponent("rv-input");
			return !__props.readonly ? (openBlock(), createBlock(_component_rv_input, {
				key: 0,
				modelValue: value.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
				disable: __props.disable,
				"info-text": __props.definition.description,
				label: __props.definition.name,
				readonly: __props.readonly,
				"show-optional-label": __props.definition.optional,
				type: type.value,
				validation: unref(v$).value
			}, null, 8, [
				"modelValue",
				"disable",
				"info-text",
				"label",
				"readonly",
				"show-optional-label",
				"type",
				"validation"
			])) : (openBlock(), createBlock(ReadOnlyParam_default, mergeProps({ key: 1 }, _ctx.$attrs, {
				name: __props.definition.name,
				value: value.value,
				"value-only": __props.valueOnly
			}), null, 16, [
				"name",
				"value",
				"value-only"
			]));
		};
	}
});
//#endregion
//#region src/components/ParamTitle.vue?vue&type=script&lang.ts
var ParamTitle_vue_vue_type_script_lang_default = defineComponent({
	components: { QIcon },
	inheritAttrs: false,
	props: {
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		hideLabel: {
			default: false,
			type: Boolean
		}
	}
});
//#endregion
//#region src/components/ParamTitle.vue
var _hoisted_1$7 = { class: "row no-wrap items-center" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
	const _component_rv_tooltip = resolveComponent("rv-tooltip");
	const _component_QIcon = resolveComponent("QIcon");
	return openBlock(), createElementBlock("div", _hoisted_1$7, [!_ctx.hideLabel ? (openBlock(), createBlock(_component_rv_ellipsis_text, mergeProps({ key: 0 }, _ctx.$attrs, {
		class: "text-subtitle3",
		disable: _ctx.disable,
		text: _ctx.definition.name
	}), null, 16, ["disable", "text"])) : createCommentVNode("", true), _ctx.definition.description ? (openBlock(), createBlock(_component_QIcon, {
		key: 1,
		class: "info-icon q-mx-xs",
		color: "black-1",
		name: "info",
		size: "16px"
	}, {
		default: withCtx(() => [createVNode(_component_rv_tooltip, null, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.definition.description), 1)]),
			_: 1
		})]),
		_: 1
	})) : createCommentVNode("", true)]);
}
var ParamTitle_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ParamTitle_vue_vue_type_script_lang_default, [["render", _sfc_render$1]]);
//#endregion
//#region src/components/params/UnsupportedParam.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$6 = { key: 0 };
//#endregion
//#region src/components/params/UnsupportedParam.vue
var UnsupportedParam_default = /* @__PURE__ */ defineComponent({
	__name: "UnsupportedParam",
	props: {
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		modelValue: {
			default: void 0,
			type: [
				Number,
				Object,
				String,
				Boolean
			]
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	setup(__props) {
		const props = __props;
		const value = computed(() => {
			return JSON.stringify(props.modelValue, null, 2) ?? "(Unsupported type)";
		});
		return (_ctx, _cache) => {
			return !__props.readonly ? (openBlock(), createElementBlock("div", _hoisted_1$6, [createVNode(ParamTitle_default, {
				definition: __props.definition,
				disable: __props.disable
			}, null, 8, ["definition", "disable"]), createElementVNode("span", { class: normalizeClass(["text-body3 text-grey-1", { "disabled": __props.disable }]) }, " Unsupported parameter type (" + toDisplayString(__props.definition.type) + ") ", 3)])) : (openBlock(), createBlock(ReadOnlyParam_default, mergeProps({ key: 1 }, _ctx.$attrs, {
				name: __props.definition.name,
				value: value.value,
				"value-only": __props.valueOnly
			}), null, 16, [
				"name",
				"value",
				"value-only"
			]));
		};
	}
});
//#endregion
//#region src/components/params/index.ts
var ComponentMap = {
	Blob: FileParam_default,
	Boolean: BooleanParam_default,
	Float: FloatParam_default,
	FloatRange: FloatRangeParam_default,
	Integer: IntegerParam_default,
	List: ListParam_default,
	Object: GroupParam_default,
	Size2D: Size2DParam_default,
	Text: TextParam_default,
	URI: /* @__PURE__ */ defineComponent({
		__name: "UriParam",
		props: {
			definition: {
				required: true,
				type: Object
			},
			disable: {
				default: false,
				type: Boolean
			},
			modelValue: {
				default: void 0,
				type: String
			},
			readonly: {
				default: false,
				type: Boolean
			},
			valueOnly: {
				default: false,
				type: Boolean
			}
		},
		emits: ["update:modelValue"],
		setup(__props, { emit: __emit }) {
			const props = __props;
			const isWebhookUrl = computed(() => {
				const { widget } = props.definition;
				return widget === "webhook";
			});
			const url = ref(props.modelValue);
			const emit = __emit;
			function onBlur() {
				try {
					const urlObject = url.value ? buildParameterValue("URI", url.value) : void 0;
					url.value = urlObject ? urlObject.toString() : "";
					emit("update:modelValue", urlObject);
				} catch (err) {
					console.log(err);
				}
			}
			const uriRegex = /(?<scheme>.*):\/\/(?<authority>[^/]*)(?:\/(?<path>[^/?]*))?(?:\?(?<query>[^#]*))?(?:#(?<fragment>.*))?/;
			const urlRegex = /^https?:\/\/(\S+(?::\S+@))?([a-zA-Z0-9-:]+\.)*[a-zA-Z0-9-:]{2,}(\/[^\s]*)?$/;
			const v$ = useVuelidate(computed(() => ({ value: ValidationBuilder.withLabel(props.definition.name).requiredIf(!props.definition.optional).regex(isWebhookUrl.value ? urlRegex : uriRegex).rules })), computed(() => ({ value: url.value })), { $autoDirty: true });
			return (_ctx, _cache) => {
				const _component_rv_input = resolveComponent("rv-input");
				return !__props.readonly ? (openBlock(), createBlock(_component_rv_input, {
					key: 0,
					modelValue: url.value,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => url.value = $event),
					"bottom-slots": "",
					disable: __props.disable,
					"info-text": __props.definition.description,
					label: __props.definition.name,
					readonly: __props.readonly,
					"show-optional-label": __props.definition.optional,
					validation: unref(v$).value,
					onBlur
				}, null, 8, [
					"modelValue",
					"disable",
					"info-text",
					"label",
					"readonly",
					"show-optional-label",
					"validation"
				])) : (openBlock(), createBlock(ReadOnlyParam_default, mergeProps({ key: 1 }, _ctx.$attrs, {
					name: __props.definition.name,
					value: url.value,
					"value-only": __props.valueOnly
				}), null, 16, [
					"name",
					"value",
					"value-only"
				]));
			};
		}
	})
};
function mapToComponent(definition, extraComponents = []) {
	for (const entry of extraComponents) if (entry.supports(definition)) return entry.component;
	if (definition.type === "Text" && definition.enum?.length) return EnumParam_default;
	if (definition.type === "Dict" && definition.values.type === "Boolean" && definition.keys?.enum != null) return DictBoolParam_default;
	if (definition.type === "Dict" && (definition.values.type === "Text" || definition.values.type === "Integer" || definition.values.type === "Float")) return DictKeyValueParam_default;
	const component = ComponentMap[definition.type];
	if (!component) {
		console.warn(`Could not find component for param ${definition.name} with type ${definition.type}`);
		return UnsupportedParam_default;
	}
	return component;
}
//#endregion
//#region src/components/Parameter.vue
var Parameter_default = /* @__PURE__ */ defineComponent({
	__name: "Parameter",
	props: {
		dataDependencies: {
			default: void 0,
			type: Object
		},
		definition: {
			required: true,
			type: Object
		},
		disable: {
			default: false,
			type: Boolean
		},
		modelValue: {
			default: void 0,
			type: [
				Number,
				Object,
				String,
				Boolean
			]
		},
		/**
		* Daemon parameter requires project to be known.
		*
		* If it is not provided, the daemon parameter loads the project
		* based on the projectName route parameter.
		*/
		project: {
			default: void 0,
			type: Object
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { extraComponents } = useOptions();
		const ParamComponent = mapToComponent(props.definition, extraComponents);
		function onUpdateModelValue(value, isDefaultValue) {
			emit("update:modelValue", value, isDefaultValue);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(ParamComponent), {
				"data-dependencies": __props.dataDependencies,
				definition: __props.definition,
				disable: __props.disable,
				"model-value": __props.modelValue,
				project: __props.project,
				readonly: __props.readonly,
				"value-only": __props.valueOnly,
				"onUpdate:modelValue": onUpdateModelValue
			}, null, 8, [
				"data-dependencies",
				"definition",
				"disable",
				"model-value",
				"project",
				"readonly",
				"value-only"
			]);
		};
	}
});
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/common/HttpStatusCode.js
var HttpStatusCode;
(function(HttpStatusCode) {
	/**
	* The server has received the request headers and the client should proceed to send the request body
	* (in the case of a request for which a body needs to be sent; for example, a POST request).
	* Sending a large request body to a server after a request has been rejected for inappropriate headers would be inefficient.
	* To have a server check the request's headers, a client must send Expect: 100-continue as a header in its initial request
	* and receive a 100 Continue status code in response before sending the body. The response 417 Expectation Failed indicates the request should not be continued.
	*/
	HttpStatusCode[HttpStatusCode["CONTINUE"] = 100] = "CONTINUE";
	/**
	* The requester has asked the server to switch protocols and the server has agreed to do so.
	*/
	HttpStatusCode[HttpStatusCode["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
	/**
	* A WebDAV request may contain many sub-requests involving file operations, requiring a long time to complete the request.
	* This code indicates that the server has received and is processing the request, but no response is available yet.
	* This prevents the client from timing out and assuming the request was lost.
	*/
	HttpStatusCode[HttpStatusCode["PROCESSING"] = 102] = "PROCESSING";
	/**
	* Standard response for successful HTTP requests.
	* The actual response will depend on the request method used.
	* In a GET request, the response will contain an entity corresponding to the requested resource.
	* In a POST request, the response will contain an entity describing or containing the result of the action.
	*/
	HttpStatusCode[HttpStatusCode["OK"] = 200] = "OK";
	/**
	* The request has been fulfilled, resulting in the creation of a new resource.
	*/
	HttpStatusCode[HttpStatusCode["CREATED"] = 201] = "CREATED";
	/**
	* The request has been accepted for processing, but the processing has not been completed.
	* The request might or might not be eventually acted upon, and may be disallowed when processing occurs.
	*/
	HttpStatusCode[HttpStatusCode["ACCEPTED"] = 202] = "ACCEPTED";
	/**
	* SINCE HTTP/1.1
	* The server is a transforming proxy that received a 200 OK from its origin,
	* but is returning a modified version of the origin's response.
	*/
	HttpStatusCode[HttpStatusCode["NON_AUTHORITATIVE_INFORMATION"] = 203] = "NON_AUTHORITATIVE_INFORMATION";
	/**
	* The server successfully processed the request and is not returning any content.
	*/
	HttpStatusCode[HttpStatusCode["NO_CONTENT"] = 204] = "NO_CONTENT";
	/**
	* The server successfully processed the request, but is not returning any content.
	* Unlike a 204 response, this response requires that the requester reset the document view.
	*/
	HttpStatusCode[HttpStatusCode["RESET_CONTENT"] = 205] = "RESET_CONTENT";
	/**
	* The server is delivering only part of the resource (byte serving) due to a range header sent by the client.
	* The range header is used by HTTP clients to enable resuming of interrupted downloads,
	* or split a download into multiple simultaneous streams.
	*/
	HttpStatusCode[HttpStatusCode["PARTIAL_CONTENT"] = 206] = "PARTIAL_CONTENT";
	/**
	* The message body that follows is an XML message and can contain a number of separate response codes,
	* depending on how many sub-requests were made.
	*/
	HttpStatusCode[HttpStatusCode["MULTI_STATUS"] = 207] = "MULTI_STATUS";
	/**
	* The members of a DAV binding have already been enumerated in a preceding part of the (multistatus) response,
	* and are not being included again.
	*/
	HttpStatusCode[HttpStatusCode["ALREADY_REPORTED"] = 208] = "ALREADY_REPORTED";
	/**
	* The server has fulfilled a request for the resource,
	* and the response is a representation of the result of one or more instance-manipulations applied to the current instance.
	*/
	HttpStatusCode[HttpStatusCode["IM_USED"] = 226] = "IM_USED";
	/**
	* Indicates multiple options for the resource from which the client may choose (via agent-driven content negotiation).
	* For example, this code could be used to present multiple video format options,
	* to list files with different filename extensions, or to suggest word-sense disambiguation.
	*/
	HttpStatusCode[HttpStatusCode["MULTIPLE_CHOICES"] = 300] = "MULTIPLE_CHOICES";
	/**
	* This and all future requests should be directed to the given URI.
	*/
	HttpStatusCode[HttpStatusCode["MOVED_PERMANENTLY"] = 301] = "MOVED_PERMANENTLY";
	/**
	* This is an example of industry practice contradicting the standard.
	* The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect
	* (the original describing phrase was "Moved Temporarily"), but popular browsers implemented 302
	* with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307
	* to distinguish between the two behaviours. However, some Web applications and frameworks
	* use the 302 status code as if it were the 303.
	*/
	HttpStatusCode[HttpStatusCode["FOUND"] = 302] = "FOUND";
	/**
	* SINCE HTTP/1.1
	* The response to the request can be found under another URI using a GET method.
	* When received in response to a POST (or PUT/DELETE), the client should presume that
	* the server has received the data and should issue a redirect with a separate GET message.
	*/
	HttpStatusCode[HttpStatusCode["SEE_OTHER"] = 303] = "SEE_OTHER";
	/**
	* Indicates that the resource has not been modified since the version specified by the request headers If-Modified-Since or If-None-Match.
	* In such case, there is no need to retransmit the resource since the client still has a previously-downloaded copy.
	*/
	HttpStatusCode[HttpStatusCode["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
	/**
	* SINCE HTTP/1.1
	* The requested resource is available only through a proxy, the address for which is provided in the response.
	* Many HTTP clients (such as Mozilla and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.
	*/
	HttpStatusCode[HttpStatusCode["USE_PROXY"] = 305] = "USE_PROXY";
	/**
	* No longer used. Originally meant "Subsequent requests should use the specified proxy."
	*/
	HttpStatusCode[HttpStatusCode["SWITCH_PROXY"] = 306] = "SWITCH_PROXY";
	/**
	* SINCE HTTP/1.1
	* In this case, the request should be repeated with another URI; however, future requests should still use the original URI.
	* In contrast to how 302 was historically implemented, the request method is not allowed to be changed when reissuing the original request.
	* For example, a POST request should be repeated using another POST request.
	*/
	HttpStatusCode[HttpStatusCode["TEMPORARY_REDIRECT"] = 307] = "TEMPORARY_REDIRECT";
	/**
	* The request and all future requests should be repeated using another URI.
	* 307 and 308 parallel the behaviors of 302 and 301, but do not allow the HTTP method to change.
	* So, for example, submitting a form to a permanently redirected resource may continue smoothly.
	*/
	HttpStatusCode[HttpStatusCode["PERMANENT_REDIRECT"] = 308] = "PERMANENT_REDIRECT";
	/**
	* The server cannot or will not process the request due to an apparent client error
	* (e.g., malformed request syntax, too large size, invalid request message framing, or deceptive request routing).
	*/
	HttpStatusCode[HttpStatusCode["BAD_REQUEST"] = 400] = "BAD_REQUEST";
	/**
	* Similar to 403 Forbidden, but specifically for use when authentication is required and has failed or has not yet
	* been provided. The response must include a WWW-Authenticate header field containing a challenge applicable to the
	* requested resource. See Basic access authentication and Digest access authentication. 401 semantically means
	* "unauthenticated",i.e. the user does not have the necessary credentials.
	*/
	HttpStatusCode[HttpStatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
	/**
	* Reserved for future use. The original intention was that this code might be used as part of some form of digital
	* cash or micro payment scheme, but that has not happened, and this code is not usually used.
	* Google Developers API uses this status if a particular developer has exceeded the daily limit on requests.
	*/
	HttpStatusCode[HttpStatusCode["PAYMENT_REQUIRED"] = 402] = "PAYMENT_REQUIRED";
	/**
	* The request was valid, but the server is refusing action.
	* The user might not have the necessary permissions for a resource.
	*/
	HttpStatusCode[HttpStatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
	/**
	* The requested resource could not be found but may be available in the future.
	* Subsequent requests by the client are permissible.
	*/
	HttpStatusCode[HttpStatusCode["NOT_FOUND"] = 404] = "NOT_FOUND";
	/**
	* A request method is not supported for the requested resource;
	* for example, a GET request on a form that requires data to be presented via POST, or a PUT request on a read-only resource.
	*/
	HttpStatusCode[HttpStatusCode["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
	/**
	* The requested resource is capable of generating only content not acceptable according to the Accept headers sent in the request.
	*/
	HttpStatusCode[HttpStatusCode["NOT_ACCEPTABLE"] = 406] = "NOT_ACCEPTABLE";
	/**
	* The client must first authenticate itself with the proxy.
	*/
	HttpStatusCode[HttpStatusCode["PROXY_AUTHENTICATION_REQUIRED"] = 407] = "PROXY_AUTHENTICATION_REQUIRED";
	/**
	* The server timed out waiting for the request.
	* According to HTTP specifications:
	* "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
	*/
	HttpStatusCode[HttpStatusCode["REQUEST_TIMEOUT"] = 408] = "REQUEST_TIMEOUT";
	/**
	* Indicates that the request could not be processed because of conflict in the request,
	* such as an edit conflict between multiple simultaneous updates.
	*/
	HttpStatusCode[HttpStatusCode["CONFLICT"] = 409] = "CONFLICT";
	/**
	* Indicates that the resource requested is no longer available and will not be available again.
	* This should be used when a resource has been intentionally removed and the resource should be purged.
	* Upon receiving a 410 status code, the client should not request the resource in the future.
	* Clients such as search engines should remove the resource from their indices.
	* Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
	*/
	HttpStatusCode[HttpStatusCode["GONE"] = 410] = "GONE";
	/**
	* The request did not specify the length of its content, which is required by the requested resource.
	*/
	HttpStatusCode[HttpStatusCode["LENGTH_REQUIRED"] = 411] = "LENGTH_REQUIRED";
	/**
	* The server does not meet one of the preconditions that the requester put on the request.
	*/
	HttpStatusCode[HttpStatusCode["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
	/**
	* The request is larger than the server is willing or able to process. Previously called "Request Entity Too Large".
	*/
	HttpStatusCode[HttpStatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
	/**
	* The URI provided was too long for the server to process. Often the result of too much data being encoded as a query-string of a GET request,
	* in which case it should be converted to a POST request.
	* Called "Request-URI Too Long" previously.
	*/
	HttpStatusCode[HttpStatusCode["URI_TOO_LONG"] = 414] = "URI_TOO_LONG";
	/**
	* The request entity has a media type which the server or resource does not support.
	* For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
	*/
	HttpStatusCode[HttpStatusCode["UNSUPPORTED_MEDIA_TYPE"] = 415] = "UNSUPPORTED_MEDIA_TYPE";
	/**
	* The client has asked for a portion of the file (byte serving), but the server cannot supply that portion.
	* For example, if the client asked for a part of the file that lies beyond the end of the file.
	* Called "Requested Range Not Satisfiable" previously.
	*/
	HttpStatusCode[HttpStatusCode["RANGE_NOT_SATISFIABLE"] = 416] = "RANGE_NOT_SATISFIABLE";
	/**
	* The server cannot meet the requirements of the Expect request-header field.
	*/
	HttpStatusCode[HttpStatusCode["EXPECTATION_FAILED"] = 417] = "EXPECTATION_FAILED";
	/**
	* This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol,
	* and is not expected to be implemented by actual HTTP servers. The RFC specifies this code should be returned by
	* teapots requested to brew coffee. This HTTP status is used as an Easter egg in some websites, including Google.com.
	*/
	HttpStatusCode[HttpStatusCode["I_AM_A_TEAPOT"] = 418] = "I_AM_A_TEAPOT";
	/**
	* The request was directed at a server that is not able to produce a response (for example because a connection reuse).
	*/
	HttpStatusCode[HttpStatusCode["MISDIRECTED_REQUEST"] = 421] = "MISDIRECTED_REQUEST";
	/**
	* The request was well-formed but was unable to be followed due to semantic errors.
	*/
	HttpStatusCode[HttpStatusCode["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
	/**
	* The resource that is being accessed is locked.
	*/
	HttpStatusCode[HttpStatusCode["LOCKED"] = 423] = "LOCKED";
	/**
	* The request failed due to failure of a previous request (e.g., a PROPPATCH).
	*/
	HttpStatusCode[HttpStatusCode["FAILED_DEPENDENCY"] = 424] = "FAILED_DEPENDENCY";
	/**
	* The client should switch to a different protocol such as TLS/1.0, given in the Upgrade header field.
	*/
	HttpStatusCode[HttpStatusCode["UPGRADE_REQUIRED"] = 426] = "UPGRADE_REQUIRED";
	/**
	* The origin server requires the request to be conditional.
	* Intended to prevent "the 'lost update' problem, where a client
	* GETs a resource's state, modifies it, and PUTs it back to the server,
	* when meanwhile a third party has modified the state on the server, leading to a conflict."
	*/
	HttpStatusCode[HttpStatusCode["PRECONDITION_REQUIRED"] = 428] = "PRECONDITION_REQUIRED";
	/**
	* The user has sent too many requests in a given amount of time. Intended for use with rate-limiting schemes.
	*/
	HttpStatusCode[HttpStatusCode["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
	/**
	* The server is unwilling to process the request because either an individual header field,
	* or all the header fields collectively, are too large.
	*/
	HttpStatusCode[HttpStatusCode["REQUEST_HEADER_FIELDS_TOO_LARGE"] = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
	/**
	* A server operator has received a legal demand to deny access to a resource or to a set of resources
	* that includes the requested resource. The code 451 was chosen as a reference to the novel Fahrenheit 451.
	*/
	HttpStatusCode[HttpStatusCode["UNAVAILABLE_FOR_LEGAL_REASONS"] = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS";
	/**
	* A generic error message, given when an unexpected condition was encountered and no more specific message is suitable.
	*/
	HttpStatusCode[HttpStatusCode["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
	/**
	* The server either does not recognize the request method, or it lacks the ability to fulfill the request.
	* Usually this implies future availability (e.g., a new feature of a web-service API).
	*/
	HttpStatusCode[HttpStatusCode["NOT_IMPLEMENTED"] = 501] = "NOT_IMPLEMENTED";
	/**
	* The server was acting as a gateway or proxy and received an invalid response from the upstream server.
	*/
	HttpStatusCode[HttpStatusCode["BAD_GATEWAY"] = 502] = "BAD_GATEWAY";
	/**
	* The server is currently unavailable (because it is overloaded or down for maintenance).
	* Generally, this is a temporary state.
	*/
	HttpStatusCode[HttpStatusCode["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
	/**
	* The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.
	*/
	HttpStatusCode[HttpStatusCode["GATEWAY_TIMEOUT"] = 504] = "GATEWAY_TIMEOUT";
	/**
	* The server does not support the HTTP protocol version used in the request
	*/
	HttpStatusCode[HttpStatusCode["HTTP_VERSION_NOT_SUPPORTED"] = 505] = "HTTP_VERSION_NOT_SUPPORTED";
	/**
	* Transparent content negotiation for the request results in a circular reference.
	*/
	HttpStatusCode[HttpStatusCode["VARIANT_ALSO_NEGOTIATES"] = 506] = "VARIANT_ALSO_NEGOTIATES";
	/**
	* The server is unable to store the representation needed to complete the request.
	*/
	HttpStatusCode[HttpStatusCode["INSUFFICIENT_STORAGE"] = 507] = "INSUFFICIENT_STORAGE";
	/**
	* The server detected an infinite loop while processing the request.
	*/
	HttpStatusCode[HttpStatusCode["LOOP_DETECTED"] = 508] = "LOOP_DETECTED";
	/**
	* Further extensions to the request are required for the server to fulfill it.
	*/
	HttpStatusCode[HttpStatusCode["NOT_EXTENDED"] = 510] = "NOT_EXTENDED";
	/**
	* The client needs to authenticate to gain network access.
	* Intended for use by intercepting proxies used to control access to the network (e.g., "captive portals" used
	* to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).
	*/
	HttpStatusCode[HttpStatusCode["NETWORK_AUTHENTICATION_REQUIRED"] = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(HttpStatusCode || (HttpStatusCode = {}));
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/lib/async.js
var CancelAsync = class extends Error {};
/**
* If operation failed - retry it until it success, but maximum 'maxRetries' times
* @param { Function } operation The function to process
* @param { Number } maxRetries The number of times to perform the operation
* @param { Number } backoff The time to wait until perform operation again
* @returns { Promise<T> }
*
* @example
* let i = 0
* const operation = () => {
*    i++
*    return i < 3 ? Promise.reject() Promise.resolve(5)
* }
* await retry(operation) // => 5
*/
async function retry(operation, maxRetries = 5, backoff = 100) {
	let retries = 0;
	let timeout = 0;
	do
		try {
			return await operation();
		} catch (error) {
			if (error instanceof CancelAsync) throw error;
			else if (++retries <= maxRetries || !maxRetries) {
				timeout += backoff;
				await wait(timeout);
			} else throw error;
		}
	while (true);
}
retry.CancelAsync = CancelAsync;
/**
* Create an async delay
* @param { Number } timeout The time to wait until resolve the promise
* @returns { Promise<void> }
*
* @example
* await wait(1000)
* console.log('some text') // => log 'some text' after 1 second
*/
async function wait(timeout) {
	return new Promise((resolve) => setTimeout(resolve, timeout));
}
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/lib/colors.js
var DEFAULT_COLORS = [
	"#F2209E",
	"#00B4FF",
	"#FFE100",
	"#00C06E",
	"#FF2424",
	"#3F60FC",
	"#BFD0FF",
	"#FF92FF",
	"#6EA600",
	"#FF800E",
	"#7CA69D",
	"#597DB3",
	"#F2C200",
	"#FFB380",
	"#A65369",
	"#FB9292",
	"#6CD9B5",
	"#D9A3B8",
	"#ACB7C9",
	"#BF7960",
	"#F2BEB6",
	"#B20030",
	"#D03D9F",
	"#C480FF",
	"#CCB499",
	"#F20061",
	"#5CE600",
	"#D48E00",
	"#8D29A6"
];
var LS_KEY = "colors";
/**
* Cache colors so that resources have consistently the same
* color while duplication between resources is avoided as much
* as possible.
*
* This class should not be used directly, prefer using the
* `colorCache` object directly.
*/
var ColorCache = class {
	colors;
	constructor(colors) {
		this.colors = colors;
	}
	getColor(context, key) {
		const cache = JSON.parse(localStorage.getItem(LS_KEY) || "{}");
		if (!cache[context]) cache[context] = {};
		if (!cache[context][key]) {
			const index = Object.keys(cache[context]).length % this.colors.length;
			cache[context][key] = this.colors[index];
			localStorage.setItem(LS_KEY, JSON.stringify(cache));
		}
		return cache[context][key];
	}
};
new ColorCache(DEFAULT_COLORS);
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/lib/date.js
var DateTemplates;
(function(DateTemplates) {
	DateTemplates["Days"] = "MMMM d";
	DateTemplates["Long"] = "yyyy-MM-dd HH:mm:ss";
	DateTemplates["Short"] = "yyyy-MM-dd";
})(DateTemplates || (DateTemplates = {}));
(() => {
	try {
		return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
	} catch {
		return false;
	}
})();
new Intl.Collator(void 0, {
	numeric: true,
	sensitivity: "base"
}).compare;
//#endregion
//#region ../../../../node_modules/@robovision/rvai-utils/build/module/lib/iterable.js
/**
* Creates a Map composed of groups extracted from {iterable} by a property key.
* @param iterable The iterable to process
* @param key The key name to get value used as Map key
* @returns Returns an Map structure with grouped values by Key
*
* @example
* groupBy([{ k: 'a', v: 1 }, { k: 'a', v: 2 }, { k: 'b', v: 3 }, { k: 'b', v: 4 }], 'k')
* // => Map(2){'a' => [{k: 'a', v: 1}, {k: 'a', v: 2}], 'b' => [{k: 'b', v: 3}, {k: 'b', v: 4}]}
*/
function groupBy(iterable, key) {
	const map = /* @__PURE__ */ new Map();
	for (const t of iterable) {
		const groupKey = t[key];
		const group = map.get(groupKey);
		if (group) group.push(t);
		else map.set(groupKey, [t]);
	}
	return map;
}
var ProbeResult;
(function(ProbeResult) {
	/**
	* No items in the list
	*/
	ProbeResult[ProbeResult["None"] = 0] = "None";
	/**
	* All items do not satisfy the predicate
	*/
	ProbeResult[ProbeResult["FalseOnly"] = 1] = "FalseOnly";
	/**
	* All items satisfy the predicate
	*/
	ProbeResult[ProbeResult["TrueOnly"] = 2] = "TrueOnly";
	/**
	* There are item that satisfy the predicate
	* and an item that do not satisfy the predicate
	*/
	ProbeResult[ProbeResult["Both"] = 3] = "Both";
})(ProbeResult || (ProbeResult = {}));
//#endregion
//#region src/utils/visibility.ts
var HIDDEN = "hidden";
/**
* Checks whether a parameter should be hidden based on its visibility metadata.
*/
function isParameterHidden(metadata, visibilityContext) {
	const visibility = metadata?.visibility;
	if (!visibility) return false;
	if (visibility === HIDDEN) return true;
	if (!visibilityContext) return false;
	return visibility.split(",").some((rule) => {
		const [context, state] = rule.trim().split(":");
		return context === visibilityContext && state === HIDDEN;
	});
}
//#endregion
//#region src/components/ParameterList.vue?vue&type=script&lang.ts
var ORDER_LAST = 9999;
var ParameterList_vue_vue_type_script_lang_default = defineComponent({
	name: "ParameterList",
	components: { QIcon },
	props: {
		advancedParamsClass: {
			default: void 0,
			type: [
				Array,
				Object,
				String
			]
		},
		disabled: {
			default: false,
			type: Boolean
		},
		groups: {
			default: () => [],
			type: Array
		},
		fields: {
			required: true,
			type: Array
		},
		groupId: {
			default: void 0,
			type: String
		},
		readonly: {
			default: false,
			type: Boolean
		},
		valueOnly: {
			default: false,
			type: Boolean
		},
		values: {
			default: void 0,
			type: Object
		},
		visibilityContext: {
			default: void 0,
			type: String
		}
	},
	emits: ["update:toggle"],
	setup(props) {
		const expanded = ref(false);
		const groupedParams = computed(() => groupBy(props.fields, "groupId"));
		const toggleParamKeys = computed(() => new Set(props.groups?.flatMap((g) => Object.keys(g.toggles ?? {}))));
		const allParams = computed(() => props.groupId ? groupedParams.value.get(props.groupId) : groupedParams.value.get(null));
		const visibleParams = computed(() => allParams.value?.filter((p) => !isParameterHidden(p?.metadata, props.visibilityContext)));
		const nonToggleParams = computed(() => visibleParams.value?.filter((p) => !toggleParamKeys.value.has(p.key)));
		const params = computed(() => nonToggleParams.value?.filter((p) => !isAdvanceParam(p)));
		const advancedParams = computed(() => nonToggleParams.value?.filter(isAdvanceParam));
		function getGroupOrder(group) {
			const idx = props.fields.findIndex((p) => p.groupId === group.id);
			return idx >= 0 ? idx : null;
		}
		function getOrder(v) {
			const idx = props.fields.indexOf(v);
			return idx >= 0 ? idx : null;
		}
		function isAdvanceParam(v) {
			return v?.metadata?.expertise === "advanced";
		}
		function getGroupToggle(group) {
			const toggleKey = Object.keys(group.toggles ?? {})[0];
			if (!toggleKey) return null;
			return props.fields.find((p) => p.key === toggleKey && !isParameterHidden(p?.metadata, props.visibilityContext));
		}
		function isGroupVisible(group) {
			const hasVisibleFields = groupedParams.value.get(group.id)?.some((p) => !isParameterHidden(p?.metadata, props.visibilityContext));
			const subGroups = group.subGroups ?? [];
			return hasVisibleFields || subGroups.some(isGroupVisible);
		}
		function isGroupContentVisible(group) {
			const toggle = getGroupToggle(group);
			if (!toggle) return true;
			const expectedValue = group.toggles?.[toggle.key];
			return props.values?.[toggle.key] === expectedValue;
		}
		return {
			advancedParams,
			expanded,
			getGroupOrder,
			getGroupToggle,
			getOrder,
			groupedParams,
			isGroupContentVisible,
			isGroupVisible,
			ORDER_LAST,
			params
		};
	}
});
//#endregion
//#region src/components/ParameterList.vue
var _hoisted_1$5 = { class: "row no-wrap items-baseline" };
var _hoisted_2$3 = {
	class: "text-subtitle3 q-pl-xs",
	style: { "white-space": "nowrap" }
};
var _hoisted_3 = ["data-automation"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
	const _component_rv_tooltip = resolveComponent("rv-tooltip");
	const _component_q_icon = resolveComponent("q-icon");
	const _component_ParameterList = resolveComponent("ParameterList", true);
	const _component_rv_expansion_item = resolveComponent("rv-expansion-item");
	return openBlock(), createElementBlock("div", normalizeProps(guardReactiveProps(_ctx.$attrs)), [
		(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.groups, (group) => {
			return openBlock(), createElementBlock(Fragment, { key: group.id }, [_ctx.isGroupVisible(group) && _ctx.readonly && _ctx.getGroupToggle(group) && !_ctx.isGroupContentVisible(group) ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: "row no-wrap items-baseline q-mb-sm",
				style: normalizeStyle({ order: _ctx.getGroupOrder(group) })
			}, [createVNode(_component_rv_ellipsis_text, {
				class: "text-body3",
				text: _ctx.getGroupToggle(group).name
			}, null, 8, ["text"]), createElementVNode("div", _hoisted_1$5, [createTextVNode(toDisplayString(_ctx.$t("rvai-params.general.symbols.colon")) + " ", 1), createElementVNode("span", _hoisted_2$3, toDisplayString(_ctx.$t("rvai-params.general.no")), 1)])], 4)) : _ctx.isGroupVisible(group) ? (openBlock(), createBlock(_component_rv_expansion_item, {
				key: 1,
				border: "",
				class: "q-mb-sm",
				"content-class": {
					"q-mt-sm": _ctx.readonly && !group.description,
					"q-pt-md": !_ctx.readonly && !group.description,
					"q-pt-sm": group.description
				},
				"data-automation": _ctx.getGroupToggle(group) ? `parameter-list__group-toggle__${_ctx.getGroupToggle(group).key}` : void 0,
				"default-opened": !_ctx.getGroupToggle(group),
				disable: _ctx.disabled && !!_ctx.getGroupToggle(group),
				label: _ctx.getGroupToggle(group)?.name ?? group.name,
				"model-value": _ctx.isGroupContentVisible(group),
				style: normalizeStyle({ order: _ctx.getGroupOrder(group) }),
				"use-toggle": !!_ctx.getGroupToggle(group) && !_ctx.readonly && !_ctx.valueOnly,
				"onUpdate:modelValue": ($event) => _ctx.getGroupToggle(group) && _ctx.$emit("update:toggle", _ctx.getGroupToggle(group).key, $event)
			}, createSlots({
				default: withCtx(() => [group.description ? (openBlock(), createElementBlock("div", {
					key: 0,
					class: "text-small text-grey-1 q-mb-sm",
					"data-automation": `parameter-list__group__${group.id}__description`
				}, toDisplayString(group.description), 9, _hoisted_3)) : createCommentVNode("", true), createVNode(_component_ParameterList, mergeProps({ ref_for: true }, _ctx.$attrs, {
					disabled: _ctx.disabled,
					fields: _ctx.fields,
					"group-id": group.id,
					groups: group.subGroups,
					readonly: _ctx.readonly,
					"value-only": _ctx.valueOnly,
					values: _ctx.values,
					"visibility-context": _ctx.visibilityContext,
					"onUpdate:toggle": _cache[0] || (_cache[0] = (key, value) => _ctx.$emit("update:toggle", key, value))
				}), {
					param: withCtx(({ param: nested }) => [createElementVNode("div", { style: normalizeStyle({ order: _ctx.getOrder(nested) }) }, [renderSlot(_ctx.$slots, "param", { param: nested })], 4)]),
					_: 3
				}, 16, [
					"disabled",
					"fields",
					"group-id",
					"groups",
					"readonly",
					"value-only",
					"values",
					"visibility-context"
				])]),
				_: 2
			}, [_ctx.getGroupToggle(group) ? {
				name: "label",
				fn: withCtx(() => [createVNode(_component_rv_ellipsis_text, {
					class: "zero-min-width",
					text: _ctx.getGroupToggle(group).name
				}, null, 8, ["text"]), _ctx.getGroupToggle(group)?.description ? (openBlock(), createBlock(_component_q_icon, {
					key: 0,
					class: "q-ml-xs cursor-pointer",
					color: "black-1",
					name: "info",
					size: "16px"
				}, {
					default: withCtx(() => [createVNode(_component_rv_tooltip, null, {
						default: withCtx(() => [createTextVNode(toDisplayString(_ctx.getGroupToggle(group).description), 1)]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1024)) : createCommentVNode("", true)]),
				key: "0"
			} : void 0]), 1032, [
				"content-class",
				"data-automation",
				"default-opened",
				"disable",
				"label",
				"model-value",
				"style",
				"use-toggle",
				"onUpdate:modelValue"
			])) : createCommentVNode("", true)], 64);
		}), 128)),
		(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.params, (param) => {
			return openBlock(), createElementBlock("div", {
				key: param.key,
				style: normalizeStyle({ order: _ctx.getOrder(param) })
			}, [renderSlot(_ctx.$slots, "param", { param })], 4);
		}), 128)),
		_ctx.advancedParams?.length ? (openBlock(), createBlock(_component_rv_expansion_item, {
			key: 0,
			modelValue: _ctx.expanded,
			"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.expanded = $event),
			class: normalizeClass(["advanced-parameters q-pa-md border-card rounded-borders", { "q-mt-sm": _ctx.readonly }]),
			"content-class": _ctx.advancedParamsClass,
			"header-class": { "q-mb-md": _ctx.expanded && !_ctx.readonly },
			style: normalizeStyle({ order: _ctx.ORDER_LAST })
		}, {
			label: withCtx(() => [createVNode(_component_rv_ellipsis_text, {
				class: "zero-min-width text-subtitle3",
				text: _ctx.$t("rvai-params.general.text.advancedParams")
			}, null, 8, ["text"])]),
			default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.advancedParams, (param) => {
				return openBlock(), createElementBlock("div", {
					key: param.key,
					style: normalizeStyle({ order: _ctx.getOrder(param) })
				}, [renderSlot(_ctx.$slots, "param", { param })], 4);
			}), 128))]),
			_: 3
		}, 8, [
			"modelValue",
			"class",
			"content-class",
			"header-class",
			"style"
		])) : createCommentVNode("", true)
	], 16);
}
var ParameterList_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ParameterList_vue_vue_type_script_lang_default, [["render", _sfc_render]]);
//#endregion
//#region src/domain/ComponentProps.ts
var componentProps = {
	definition: {
		required: true,
		type: Object
	},
	disable: {
		default: false,
		type: Boolean
	},
	modelValue: {
		default: void 0,
		type: [
			Number,
			Object,
			String,
			Boolean
		]
	},
	/**
	* Daemon parameter requires project to be known.
	*
	* If it is not provided, the daemon parameter loads the project
	* based on the projectName route parameter.
	*/
	project: {
		default: void 0,
		type: Object
	},
	readonly: {
		default: false,
		type: Boolean
	},
	valueOnly: {
		default: false,
		type: Boolean
	}
};
//#endregion
//#region src/utils/name.ts
function generateName(baseName, names, separator = "-", useBrackets = false) {
	if (!names.includes(baseName)) return baseName;
	const regex = new RegExp(`(.+?)(?:(${separator}\\d+)|$)`);
	const match = baseName.match(regex);
	const prefix = match ? match[1] ?? "" : baseName;
	let index = 1;
	let name = "";
	do {
		name = index === 1 ? prefix : `${prefix}${separator}${useBrackets ? `(${index})` : index}`;
		++index;
	} while (names.includes(name));
	return name;
}
//#endregion
//#region src/domain/AreaMeasurement.ts
var AreaMeasurementOperator = /* @__PURE__ */ function(AreaMeasurementOperator) {
	AreaMeasurementOperator["BETWEEN"] = "between";
	AreaMeasurementOperator["GTE"] = "gte";
	AreaMeasurementOperator["LTE"] = "lte";
	return AreaMeasurementOperator;
}({});
var AREA_MEASUREMENT_VALUE_MIN = 1;
function getEmptyThreshold(existingNames) {
	return {
		classes: [],
		id: v4(),
		include_in_sampling: false,
		measurement_metadata: void 0,
		name: generateName("Threshold", existingNames),
		operator: void 0,
		value: void 0
	};
}
//#endregion
//#region src/components/daemon-params/AreaMeasurementReadOnlyItem.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$4 = ["data-automation"];
var _hoisted_2$2 = ["data-automation"];
//#endregion
//#region src/components/daemon-params/AreaMeasurementReadOnlyItem.vue
var AreaMeasurementReadOnlyItem_default = /* @__PURE__ */ defineComponent({
	__name: "AreaMeasurementReadOnlyItem",
	props: { threshold: {} },
	setup(__props) {
		const props = __props;
		const { t } = useI18n();
		const operatorValueLabel = computed(() => {
			switch (props.threshold.operator) {
				case AreaMeasurementOperator.BETWEEN: return t("rvai-params.areaMeasurement.operatorValue.between", [formatPixels(props.threshold.value_min), formatPixels(props.threshold.value_max)]);
				case AreaMeasurementOperator.GTE: return t("rvai-params.areaMeasurement.operatorValue.gte", [formatPixels(props.threshold.value)]);
				case AreaMeasurementOperator.LTE: return t("rvai-params.areaMeasurement.operatorValue.lte", [formatPixels(props.threshold.value)]);
				default: return "";
			}
		});
		const fields = computed(() => [
			{
				key: "classes",
				label: `${t("rvai-params.areaMeasurement.fields.classes")}${t("rvai-params.general.symbols.colon")}`,
				value: props.threshold.classes.join(", ")
			},
			{
				key: "value",
				label: `${t("rvai-params.areaMeasurement.fields.value")}${t("rvai-params.general.symbols.colon")}`,
				value: operatorValueLabel.value
			},
			{
				key: "measurement-metadata",
				label: `${t("rvai-params.areaMeasurement.fields.measurementMetadata")}${t("rvai-params.general.symbols.colon")}`,
				value: props.threshold.measurement_metadata ?? t("rvai-params.general.none")
			},
			{
				key: "include-in-sampling",
				label: `${t("rvai-params.areaMeasurement.fields.includeInSampling")}${t("rvai-params.general.symbols.colon")}`,
				value: props.threshold.include_in_sampling ? t("rvai-params.general.yes") : t("rvai-params.general.no")
			}
		]);
		function formatPixels(value) {
			return `${value}px`;
		}
		return (_ctx, _cache) => {
			const _component_rv_ellipsis_text = resolveComponent("rv-ellipsis-text");
			const _component_rv_expansion_item = resolveComponent("rv-expansion-item");
			return openBlock(), createBlock(_component_rv_expansion_item, {
				class: "bg-grey-5 q-pa-md zero-min-width full-width rounded-borders",
				"data-automation": `area-measurement-read-only-item-${__props.threshold.id}`,
				"default-opened": "",
				label: __props.threshold.name,
				"label-tooltip-class": "area-measurement-read-only-item-tooltip"
			}, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(fields.value, (field) => {
					return openBlock(), createElementBlock("div", {
						key: field.key,
						class: "row no-wrap text-body3 text-black-1 text-no-wrap",
						"data-automation": `area-measurement-read-only-item__${field.key}`
					}, [
						createElementVNode("span", { "data-automation": `area-measurement-read-only-item__${field.key}__label` }, toDisplayString(field.label), 9, _hoisted_2$2),
						_cache[0] || (_cache[0] = createTextVNode(" \xA0 ", -1)),
						createVNode(_component_rv_ellipsis_text, {
							class: "text-bold",
							"data-automation": `area-measurement-read-only-item__${field.key}__value`,
							text: field.value,
							"tooltip-class": "area-measurement-read-only-item-tooltip"
						}, null, 8, ["data-automation", "text"])
					], 8, _hoisted_1$4);
				}), 128))]),
				_: 1
			}, 8, ["data-automation", "label"]);
		};
	}
});
//#endregion
//#region src/components/daemon-params/AreaMeasurementReadOnly.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$3 = {
	key: 0,
	class: "column q-gutter-y-md",
	"data-automation": "area-measurement-read-only"
};
var _hoisted_2$1 = {
	key: 1,
	class: "text-body3 text-black-1 text-center",
	"data-automation": "area-measurement-read-only__no-thresholds"
};
//#endregion
//#region src/components/daemon-params/AreaMeasurementReadOnly.vue
var AreaMeasurementReadOnly_default = /* @__PURE__ */ defineComponent({
	__name: "AreaMeasurementReadOnly",
	props: { thresholds: {} },
	setup(__props) {
		return (_ctx, _cache) => {
			return __props.thresholds.length !== 0 ? (openBlock(), createElementBlock("div", _hoisted_1$3, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.thresholds, (threshold) => {
				return openBlock(), createBlock(AreaMeasurementReadOnlyItem_default, {
					key: threshold.id,
					threshold
				}, null, 8, ["threshold"]);
			}), 128))])) : (openBlock(), createElementBlock("div", _hoisted_2$1, toDisplayString(_ctx.$t("rvai-params.general.symbols.dash")), 1));
		};
	}
});
//#endregion
//#region src/components/daemon-params/AreaMeasurementForm.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$2 = { "data-automation": "area-measurement-form" };
//#endregion
//#region src/components/daemon-params/AreaMeasurementForm.vue
var AreaMeasurementForm_default = /* @__PURE__ */ defineComponent({
	__name: "AreaMeasurementForm",
	props: {
		classes: {},
		threshold: {},
		validation: {}
	},
	emits: ["update"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const v$ = computed(() => props.validation);
		const emit = __emit;
		const { t } = useI18n();
		const betweenThreshold = computed(() => {
			if (props.threshold.operator === AreaMeasurementOperator.BETWEEN) return props.threshold;
			return null;
		});
		const singleValueThreshold = computed(() => {
			if (props.threshold.operator !== AreaMeasurementOperator.BETWEEN) return props.threshold;
			return null;
		});
		const isOperatorDisabled = computed(() => {
			return props.threshold.classes.length === 0;
		});
		const isValueDisabled = computed(() => {
			return isOperatorDisabled.value || !props.threshold.operator;
		});
		const isThresholdValueMissing = computed(() => {
			if (betweenThreshold.value) return isValueDisabled.value || !betweenThreshold.value.value_min || !betweenThreshold.value.value_max;
			return isValueDisabled.value || !singleValueThreshold.value?.value;
		});
		const operatorOptions = computed(() => [
			{
				label: t("rvai-params.areaMeasurement.operators.gte"),
				value: AreaMeasurementOperator.GTE
			},
			{
				label: t("rvai-params.areaMeasurement.operators.lte"),
				value: AreaMeasurementOperator.LTE
			},
			{
				label: t("rvai-params.areaMeasurement.operators.between"),
				value: AreaMeasurementOperator.BETWEEN
			}
		]);
		function onOperatorChange(updatedOperator) {
			const thresholdToUpdate = { ...props.threshold };
			if (updatedOperator === AreaMeasurementOperator.BETWEEN) {
				if ("value" in thresholdToUpdate) delete thresholdToUpdate.value;
				emit("update", Object.assign(thresholdToUpdate, {
					operator: updatedOperator,
					value_max: void 0,
					value_min: void 0
				}));
				return;
			}
			if ("value_max" in thresholdToUpdate) delete thresholdToUpdate.value_max;
			if ("value_min" in thresholdToUpdate) delete thresholdToUpdate.value_min;
			emit("update", {
				...thresholdToUpdate,
				operator: updatedOperator,
				value: void 0
			});
		}
		function onChange(value) {
			const updatedThreshold = { ...props.threshold };
			emit("update", Object.assign(updatedThreshold, value));
		}
		return (_ctx, _cache) => {
			const _component_rv_multiple_select = resolveComponent("rv-multiple-select");
			const _component_rv_select = resolveComponent("rv-select");
			const _component_rv_input = resolveComponent("rv-input");
			const _component_rv_toggle = resolveComponent("rv-toggle");
			return openBlock(), createElementBlock("div", _hoisted_1$2, [
				createVNode(_component_rv_multiple_select, {
					class: "q-mt-md",
					"data-automation": "area-measurement-form__classes",
					label: _ctx.$t("rvai-params.areaMeasurement.fields.classes"),
					"model-value": __props.threshold.classes,
					options: Object.keys(__props.classes),
					validation: v$.value.classes,
					"with-chips": "",
					"onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => onChange({ classes: val }))
				}, null, 8, [
					"label",
					"model-value",
					"options",
					"validation"
				]),
				createVNode(_component_rv_select, {
					class: "q-mt-md",
					"data-automation": "area-measurement-form__operator",
					disable: isOperatorDisabled.value,
					label: _ctx.$t("rvai-params.areaMeasurement.fields.operator"),
					"map-options": "",
					"model-value": __props.threshold.operator,
					options: operatorOptions.value,
					placeholder: _ctx.$t("rvai-params.areaMeasurement.general.selectOption"),
					validation: v$.value.operator,
					"onUpdate:modelValue": _cache[1] || (_cache[1] = (val) => onOperatorChange(val.value))
				}, null, 8, [
					"disable",
					"label",
					"model-value",
					"options",
					"placeholder",
					"validation"
				]),
				betweenThreshold.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(_component_rv_input, {
					class: "q-mt-md",
					"data-automation": "area-measurement-form__value-min",
					disable: isValueDisabled.value,
					hint: _ctx.$t("rvai-params.areaMeasurement.fields.valueHint"),
					label: _ctx.$t("rvai-params.areaMeasurement.fields.minValueLabel"),
					min: unref(1),
					"model-value": betweenThreshold.value.value_min,
					type: "number",
					validation: v$.value.value_min,
					"onUpdate:modelValue": _cache[2] || (_cache[2] = (val) => onChange({ value_min: Number(val) }))
				}, null, 8, [
					"disable",
					"hint",
					"label",
					"min",
					"model-value",
					"validation"
				]), createVNode(_component_rv_input, {
					class: "q-mt-sm",
					"data-automation": "area-measurement-form__value-max",
					disable: isValueDisabled.value,
					hint: _ctx.$t("rvai-params.areaMeasurement.fields.valueHint"),
					label: _ctx.$t("rvai-params.areaMeasurement.fields.maxValueLabel"),
					min: unref(1),
					"model-value": betweenThreshold.value.value_max,
					type: "number",
					validation: v$.value.value_max,
					"onUpdate:modelValue": _cache[3] || (_cache[3] = (val) => onChange({ value_max: Number(val) }))
				}, null, 8, [
					"disable",
					"hint",
					"label",
					"min",
					"model-value",
					"validation"
				])], 64)) : (openBlock(), createBlock(_component_rv_input, {
					key: 1,
					class: "q-mt-md",
					"data-automation": "area-measurement-form__value",
					disable: isValueDisabled.value,
					hint: _ctx.$t("rvai-params.areaMeasurement.fields.valueHint"),
					label: _ctx.$t("rvai-params.areaMeasurement.fields.valueLabel"),
					min: unref(1),
					"model-value": singleValueThreshold.value?.value,
					type: "number",
					validation: v$.value.value,
					"onUpdate:modelValue": _cache[4] || (_cache[4] = (val) => onChange({ value: Number(val) }))
				}, null, 8, [
					"disable",
					"hint",
					"label",
					"min",
					"model-value",
					"validation"
				])),
				createVNode(_component_rv_input, {
					class: "q-mt-sm",
					"data-automation": "area-measurement-form__measurement-metadata",
					disable: isThresholdValueMissing.value,
					"info-text": _ctx.$t("rvai-params.areaMeasurement.fields.measurementMetadataInfoText"),
					label: _ctx.$t("rvai-params.areaMeasurement.fields.measurementMetadata"),
					"model-value": __props.threshold.measurement_metadata,
					"show-optional-label": "",
					validation: v$.value.measurement_metadata,
					"onUpdate:modelValue": _cache[5] || (_cache[5] = (val) => onChange({ measurement_metadata: val }))
				}, null, 8, [
					"disable",
					"info-text",
					"label",
					"model-value",
					"validation"
				]),
				createVNode(_component_rv_toggle, {
					class: "q-mt-md",
					"data-automation": "area-measurement-form__include-in-sampling",
					disable: isThresholdValueMissing.value,
					"info-text": _ctx.$t("rvai-params.areaMeasurement.fields.includeInSamplingInfoText"),
					label: _ctx.$t("rvai-params.areaMeasurement.fields.includeInSampling"),
					"model-value": __props.threshold.include_in_sampling,
					validation: v$.value.include_in_sampling,
					"onUpdate:modelValue": _cache[6] || (_cache[6] = (val) => onChange({ include_in_sampling: val }))
				}, null, 8, [
					"disable",
					"info-text",
					"label",
					"model-value",
					"validation"
				])
			]);
		};
	}
});
//#endregion
//#region src/components/daemon-params/AreaMeasurementThreshold.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$1 = { class: "row items-center justify-between full-width no-wrap" };
var _hoisted_2 = { class: "min-width-0 overflow-hidden q-pr-sm flex-grow" };
//#endregion
//#region src/components/daemon-params/AreaMeasurementThreshold.vue
var AreaMeasurementThreshold_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "AreaMeasurementThreshold",
	props: {
		classes: {},
		deleteDisabled: { type: Boolean },
		existingNames: {},
		threshold: {}
	},
	emits: [
		"delete",
		"update",
		"update:name"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const expanded = ref(true);
		const existingNamesRef = computed(() => props.existingNames);
		const betweenThreshold = computed(() => {
			if (props.threshold.operator === AreaMeasurementOperator.BETWEEN) return props.threshold;
			return null;
		});
		const singleValueThreshold = computed(() => {
			if (props.threshold.operator !== AreaMeasurementOperator.BETWEEN) return props.threshold;
			return null;
		});
		const nameValidationRules = ValidationBuilder.$t("rvai-params.areaMeasurement.general.name").required.wordsWithSpaces.maxLength(255).uniqueValue(existingNamesRef).rules;
		const formValidationRules = computed(() => {
			const baseRules = {
				classes: ValidationBuilder.$t("rvai-params.areaMeasurement.fields.classes").custom((value) => value.length > 0, "rvai-params.errors.selectionRequired").rules,
				include_in_sampling: ValidationBuilder.$t("rvai-params.areaMeasurement.fields.includeInSampling").required.rules,
				measurement_metadata: ValidationBuilder.$t("rvai-params.areaMeasurement.fields.measurementMetadata").wordsWithSpaces.maxLength(255).rules,
				operator: ValidationBuilder.$t("rvai-params.areaMeasurement.fields.operator").required.rules
			};
			if (betweenThreshold.value) return {
				...baseRules,
				value_max: ValidationBuilder.$t("rvai-params.areaMeasurement.fields.value").required.numbersOnly.minValue(1).custom((value) => value > (betweenThreshold.value?.value_min ?? 0), "rvai-params.areaMeasurement.fields.valueGreaterThan").rules,
				value_min: ValidationBuilder.$t("rvai-params.areaMeasurement.fields.value").required.numbersOnly.minValue(1).rules
			};
			else return {
				...baseRules,
				value: ValidationBuilder.$t("rvai-params.areaMeasurement.fields.value").required.numbersOnly.minValue(1).rules
			};
		});
		const formValidationState = computed(() => {
			const baseState = {
				classes: props.threshold.classes,
				include_in_sampling: props.threshold.include_in_sampling,
				measurement_metadata: props.threshold.measurement_metadata,
				operator: props.threshold.operator
			};
			if (betweenThreshold.value) return {
				...baseState,
				value_max: betweenThreshold.value.value_max,
				value_min: betweenThreshold.value.value_min
			};
			return {
				...baseState,
				value: singleValueThreshold.value?.value
			};
		});
		const formValidation = useVuelidate(formValidationRules, computed(() => formValidationState.value));
		const emit = __emit;
		const nameRef = useTemplateRef("nameRef");
		const shouldEditNameAfterMenuHide = ref(false);
		function onNameClick(event) {
			if (nameRef.value?.editing) {
				event.stopPropagation();
				event.preventDefault();
			}
		}
		function onEditThreshold() {
			shouldEditNameAfterMenuHide.value = true;
		}
		function onMenuHide() {
			if (!shouldEditNameAfterMenuHide.value) return;
			shouldEditNameAfterMenuHide.value = false;
			nameRef.value?.edit();
		}
		function onUpdateName(updatedName) {
			if (!updatedName) return;
			emit("update:name", updatedName);
		}
		return (_ctx, _cache) => {
			const _component_rv_editable_text = resolveComponent("rv-editable-text");
			const _component_rv_button = resolveComponent("rv-button");
			const _component_rv_expansion_item = resolveComponent("rv-expansion-item");
			return openBlock(), createBlock(_component_rv_expansion_item, {
				modelValue: expanded.value,
				"onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => expanded.value = $event),
				border: "",
				class: "q-mt-md",
				"data-automation": "area-measurement-threshold",
				"default-opened": "",
				label: __props.threshold.name,
				"no-hover-animation": ""
			}, {
				label: withCtx(() => [createElementVNode("div", _hoisted_1$1, [createElementVNode("div", _hoisted_2, [createVNode(_component_rv_editable_text, {
					ref_key: "nameRef",
					ref: nameRef,
					class: "text-black-1 area-measurement-threshold__name",
					"data-automation": "area-measurement-threshold__name",
					"model-value": __props.threshold.name,
					"validation-rules": unref(nameValidationRules),
					onClick: onNameClick,
					"onUpdate:modelValue": onUpdateName
				}, null, 8, ["model-value", "validation-rules"])]), createVNode(_component_rv_button, {
					class: "flex-shrink-0",
					color: "grey-1",
					"data-automation": "area-measurement-threshold__menu",
					icon: "mdi-dots-horizontal",
					tertiary: "",
					onClick: _cache[1] || (_cache[1] = withModifiers(() => {}, ["prevent", "stop"]))
				}, {
					default: withCtx(() => [createVNode(unref(QMenu), {
						anchor: expanded.value ? "bottom left" : "top left",
						"auto-close": "",
						"max-height": "81px",
						self: "top left",
						onHide: onMenuHide
					}, {
						default: withCtx(() => [createVNode(unref(QList), { separator: "" }, {
							default: withCtx(() => [createVNode(unref(QItem), {
								clickable: "",
								"data-automation": "area-measurement-threshold__edit",
								onClick: onEditThreshold
							}, {
								default: withCtx(() => [createVNode(unref(QItemLabel), null, {
									default: withCtx(() => [createTextVNode(toDisplayString(_ctx.$t("rvai-params.areaMeasurement.general.edit")), 1)]),
									_: 1
								})]),
								_: 1
							}), createVNode(unref(QItem), {
								clickable: "",
								"data-automation": "area-measurement-threshold__delete",
								disable: __props.deleteDisabled,
								onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("delete"))
							}, {
								default: withCtx(() => [createVNode(unref(QItemLabel), null, {
									default: withCtx(() => [createTextVNode(toDisplayString(_ctx.$t("rvai-params.areaMeasurement.general.delete")), 1)]),
									_: 1
								})]),
								_: 1
							}, 8, ["disable"])]),
							_: 1
						})]),
						_: 1
					}, 8, ["anchor"])]),
					_: 1
				})])]),
				default: withCtx(() => [createVNode(AreaMeasurementForm_default, {
					classes: __props.classes,
					threshold: __props.threshold,
					validation: unref(formValidation),
					onUpdate: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("update", $event))
				}, null, 8, [
					"classes",
					"threshold",
					"validation"
				])]),
				_: 1
			}, 8, ["modelValue", "label"]);
		};
	}
}), [["__scopeId", "data-v-b0e69ebd"]]);
//#endregion
//#region src/components/daemon-params/AreaMeasurement.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = {
	key: 1,
	"data-automation": "area-measurement"
};
//#endregion
//#region src/components/daemon-params/AreaMeasurement.vue
var AreaMeasurement_default = /* @__PURE__ */ defineComponent({
	__name: "AreaMeasurement",
	props: /*@__PURE__*/ mergeModels({
		classes: {},
		readOnly: {
			type: Boolean,
			default: false
		}
	}, {
		"modelValue": { required: true },
		"modelModifiers": {}
	}),
	emits: ["update:modelValue"],
	setup(__props) {
		const modelValue = useModel(__props, "modelValue");
		const v$ = useVuelidate();
		const currentModelValue = ref(modelValue.value.length === 0 ? [getEmptyThreshold([])] : modelValue.value);
		function emitModelValue() {
			nextTick(() => {
				modelValue.value = v$.value.$invalid ? [] : currentModelValue.value;
			});
		}
		function updateThreshold(updatedThreshold) {
			currentModelValue.value = currentModelValue.value.map((threshold) => {
				return threshold.id === updatedThreshold.id ? updatedThreshold : threshold;
			});
			emitModelValue();
		}
		function onAddThreshold() {
			const existingNames = currentModelValue.value.map((rule) => rule.name);
			currentModelValue.value = [...currentModelValue.value, getEmptyThreshold(existingNames)];
			emitModelValue();
		}
		function onDeleteThreshold(threshold) {
			currentModelValue.value = currentModelValue.value.filter((rule) => rule.id !== threshold.id);
			emitModelValue();
		}
		function onUpdateThresholdName(changedName, thresholdToUpdate) {
			currentModelValue.value = currentModelValue.value.map((threshold) => {
				if (threshold.id === thresholdToUpdate.id) return {
					...threshold,
					name: changedName
				};
				return threshold;
			});
			emitModelValue();
		}
		return (_ctx, _cache) => {
			const _component_rv_button = resolveComponent("rv-button");
			return __props.readOnly ? (openBlock(), createBlock(AreaMeasurementReadOnly_default, {
				key: 0,
				thresholds: modelValue.value
			}, null, 8, ["thresholds"])) : (openBlock(), createElementBlock("div", _hoisted_1, [createVNode(_component_rv_button, {
				class: "full-width",
				"data-automation": "area-measurement__add-threshold",
				label: _ctx.$t("rvai-params.areaMeasurement.general.addThreshold"),
				secondary: "",
				size: "sm",
				onClick: onAddThreshold
			}, null, 8, ["label"]), (openBlock(true), createElementBlock(Fragment, null, renderList(currentModelValue.value, (threshold) => {
				return openBlock(), createBlock(AreaMeasurementThreshold_default, {
					key: threshold.id,
					classes: __props.classes,
					"delete-disabled": currentModelValue.value.length === 1,
					"existing-names": currentModelValue.value.filter((t) => t.id !== threshold.id).map((t) => t.name),
					threshold,
					onDelete: ($event) => onDeleteThreshold(threshold),
					onUpdate: updateThreshold,
					"onUpdate:name": ($event) => onUpdateThresholdName($event, threshold)
				}, null, 8, [
					"classes",
					"delete-disabled",
					"existing-names",
					"threshold",
					"onDelete",
					"onUpdate:name"
				]);
			}), 128))]));
		};
	}
});
//#endregion
//#region src/components/index.ts
var components_exports = /* @__PURE__ */ __exportAll({
	AreaMeasurement: () => AreaMeasurement_default,
	ParamTitle: () => ParamTitle_default,
	Parameter: () => Parameter_default,
	ParameterList: () => ParameterList_default,
	ReadOnlyParam: () => ReadOnlyParam_default
});
//#endregion
//#region src/i18n/en.json
var en_default = { "rvai-params": {
	"areaMeasurement": {
		"fields": {
			"classes": "Classes",
			"includeInSampling": "Include in sampling",
			"includeInSamplingInfoText": "Use this measurement as a sampling condition during inference. When enabled, recording occurs even if no other sampling conditions are satisfied.",
			"measurementMetadata": "Measurement metadata",
			"measurementMetadataInfoText": "Add metadata to describe the origin or context of this measurement in the imported data.",
			"minValueLabel": "Minimum value (px)",
			"maxValueLabel": "Maximum value (px)",
			"operator": "Operator",
			"value": "Value",
			"valueLabel": "Value (px)",
			"valueHint": "Value must contain only numbers",
			"valueGreaterThan": "This value must be greater than the first value."
		},
		"general": {
			"addThreshold": "Add new threshold",
			"delete": "Delete",
			"edit": "Edit",
			"name": "Name",
			"selectOption": "Select option"
		},
		"operators": {
			"between": "is between (inclusive)",
			"gte": "is greater than or equal to",
			"lte": "is less than or equal to"
		},
		"operatorValue": {
			"between": "is between {0} - {1}",
			"gte": "is greater than or equal to {0}",
			"lte": "is less than or equal to {0}"
		}
	},
	"errors": {
		"bothAreRequired": "Both key and value are required",
		"duplicatedKeys": "Keys should be unique",
		"selectionRequired": "This field requires at least one selection"
	},
	"general": {
		"allSelected": "All selected",
		"key": "key",
		"no": "No",
		"none": "None",
		"text": { "advancedParams": "Advanced parameters" },
		"symbols": {
			"colon": ":",
			"dash": "-"
		},
		"unset": "Unset",
		"value": "value",
		"yes": "Yes"
	}
} };
//#endregion
//#region src/setup.ts
function initializeI18n() {
	useI18n().mergeLocaleMessage("en", en_default);
}
function initialize(options) {
	initializeI18n();
	provideOptions(options);
}
//#endregion
//#region src/entry.esm.ts
var PREFIX = "Rv";
var install = function(app) {
	Object.entries(components_exports).forEach(([name, component]) => {
		app.component(`${PREFIX}${name}`, component);
	});
};
//#endregion
//#region src/entry.ts
var entry_default = { install };
//#endregion
export { AREA_MEASUREMENT_VALUE_MIN, AreaMeasurement_default as AreaMeasurement, AreaMeasurementOperator, ParamTitle_default as ParamTitle, Parameter_default as Parameter, ParameterList_default as ParameterList, ReadOnlyParam_default as ReadOnlyParam, componentProps, entry_default as default, generateName, getEmptyThreshold, initialize, isParameterHidden, provideOptions, useOptions };

//# sourceMappingURL=index.es.js.map